var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetpwdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.07,
    y: 341.8,
    width: 35.16,
    height: 11.19,
    transform: "translate(839.3 694.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.68,
    y: 148.8,
    width: 35.16,
    height: 11.19,
    transform: "translate(878.52 308.79) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.68,367.1l17.7-.3,8.75-.12,8.71,0-.46.46,0-11.19.5.5-17.58-.07-8.79-.09-8.79-.11.24-.23Zm0,0-.23-11.19v-.24h.24l8.79-.11,8.79-.08,17.58-.07h.5v.5l0,11.19v.45h-.45l-8.87,0-8.83-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.85,339.15l17.7-.29,8.75-.12,8.71-.05-.46.46,0-11.19.5.5-17.58-.07-8.79-.08-8.79-.11.24-.24Zm0,0L129.61,328v-.24h.24l8.79-.11,8.79-.08,17.58-.07h.5v.5l0,11.19v.46H165l-8.87,0-8.83-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,353.26l17.7-.29,8.75-.12,8.71-.05-.46.46,0-11.19.5.5L167,342.5l-8.79-.08-8.79-.11.24-.24Zm0,0-.23-11.19v-.24h.24l8.79-.11,8.79-.08,17.58-.07h.5v.5l0,11.19v.46h-.45l-8.87,0-8.83-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 327.96,
    width: 35.16,
    height: 11.19,
    transform: "translate(373.15 667.11) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.16,
    y: 355.91,
    width: 35.16,
    height: 11.19,
    transform: "translate(121.48 723) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.77,
    y: 44.93,
    width: 35.16,
    height: 11.19,
    transform: "translate(160.7 101.06) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.16,70.23l17.7-.29,8.75-.12,8.71,0-.46.45,0-11.19.5.5-17.58-.07L52,59.39l-8.79-.11L43.4,59Zm0,0L42.92,59v-.23h.24L52,58.7l8.79-.09,17.58-.07h.5V59l0,11.19v.46h-.45l-8.87,0-8.83-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.07,56.12l17.7-.29,8.75-.12,8.71,0-.46.45,0-11.19.5.5-17.58-.07-8.79-.08-8.79-.11.24-.24Zm0,0-.24-11.19V44.7h.24l8.79-.11,8.79-.09,17.58-.07h.5v.5l-.05,11.19v.46h-.45l-8.87,0-8.83-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.93,
    cy: 81.48,
    r: 43.09,
    transform: "translate(-5.86 122.91) rotate(-16.66)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.9,
    cy: 82.44,
    r: 41.11,
    transform: "translate(146.97 411.57) rotate(-61.57)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.9,
    cy: 82.44,
    r: 38.52,
    transform: "translate(-4.7 135.72) rotate(-18.3)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.55,74.26c-17.54,10.63-46.37,28.06-62.48,37.62a38.5,38.5,0,0,1-10.52-14.15l53.28-49.39A38.59,38.59,0,0,1,456.55,74.26Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.39,83.78a38,38,0,0,1-2.54,12.52l-48,22.72a38,38,0,0,1-6.07-2.61C415.25,108,441.77,92.77,457.39,83.78Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.53,
    y: 46.72,
    width: 0.74,
    height: 5.84,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.13,
    y: 51.11,
    width: 0.75,
    height: 5.84,
    transform: "translate(26.9 208.47) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.13,
    y: 63.12,
    width: 0.74,
    height: 5.84,
    transform: "translate(138.04 371.18) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.18,
    y: 82.06,
    width: 5.84,
    height: 0.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.58,
    y: 98.47,
    width: 5.84,
    height: 0.74,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, 2.91, 208.54)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.59,
    y: 110.47,
    width: 5.84,
    height: 0.74,
    transform: "translate(105.47 404.22) rotate(-60.04)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.53,
    y: 112.32,
    width: 0.74,
    height: 5.84,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.93,
    y: 107.92,
    width: 0.74,
    height: 5.84,
    transform: "translate(2.9 232.5) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.94,
    y: 95.92,
    width: 0.74,
    height: 5.84,
    transform: "translate(138.03 436.77) rotate(-59.99)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.79,
    y: 82.06,
    width: 5.84,
    height: 0.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.39,
    y: 65.66,
    width: 5.84,
    height: 0.74,
    transform: "translate(26.95 232.61) rotate(-30.01)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.39,
    y: 53.66,
    width: 5.84,
    height: 0.74,
    transform: "translate(171.03 404.13) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.46 49.36 420.73 85.04 417.08 84.99 418.47 49.35 419.46 49.36",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.69 70 417.68 85.31 415.94 82.11 441.21 69.12 441.69 70",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.15,82.44a1.25,1.25,0,1,1-1.25-1.25A1.24,1.24,0,0,1,420.15,82.44Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.71 462.77 90.03 462.52 143.35 462.44 250 462.27 356.64 462.43 409.97 462.52 463.29 462.77 409.97 463.01 356.64 463.1 250 463.27 143.35 463.1 90.03 463.01 36.71 462.77",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,335.65s.92,0,2,4c.57,2.19-2.79,20.76-2.46,40.48.25,14.8,1,31,2.11,40.25,0,0,1.08,2.17,4.63,1.51a230.87,230.87,0,0,1-4.63-42.29c-.15-13.87,2.66-29.71,2.58-40.5a9.38,9.38,0,0,1,.91-3.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.28,330.51s-4.15-3.09-4-7.81,1.8-8.38,4.11-10.61S77.51,310,77.51,310s2.59-.34,4.16,5.09,3.12,10,1.25,12.8C79.33,333.16,74.28,330.51,74.28,330.51Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.28,330.51s-4.15-3.09-4-7.81,1.8-8.38,4.11-10.61S77.51,310,77.51,310s2.59-.34,4.16,5.09,3.12,10,1.25,12.8C79.33,333.16,74.28,330.51,74.28,330.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.37,323.45s-1.78-4.6-.18-8.09,2.79-3.5,3.14-3.59,2.62.57,3.46,3.92.82,5.72.28,7.11-2.74,2.42-2.74,2.42A4.46,4.46,0,0,1,67.37,323.45Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.37,323.45s-1.78-4.6-.18-8.09,2.79-3.5,3.14-3.59,2.62.57,3.46,3.92.82,5.72.28,7.11-2.74,2.42-2.74,2.42A4.46,4.46,0,0,1,67.37,323.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.57,313.91s-1.88.49-2.43,3.71a21.83,21.83,0,0,0,.35,7.67c.2.69.74,7.3,4.19,9.93s4.12,1,4.12,1a7.11,7.11,0,0,0,3-5.56,25.83,25.83,0,0,0-1-9.9c-.94-2.83-1.31-4.42-3.24-5.44S68.25,313.55,67.57,313.91Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.57,313.91s-1.88.49-2.43,3.71a21.83,21.83,0,0,0,.35,7.67c.2.69.74,7.3,4.19,9.93s4.12,1,4.12,1a7.11,7.11,0,0,0,3-5.56,25.83,25.83,0,0,0-1-9.9c-.94-2.83-1.31-4.42-3.24-5.44S68.25,313.55,67.57,313.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.28,337s-4.16.66-5.36-5.3.22-7.92.5-8.76-.07-1.77.59-2.79,1.08-.8,1.91-2.17,1.09-3.39,1.77-4a2.8,2.8,0,0,1,2.27-.82,23.4,23.4,0,0,1,3.54,1.47c1,.38.71,2.29,1.37,3.11s2.58,3.19,1.78,7.73-1.36,7.58-3.37,9.29S77.65,337,76.28,337Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.39,336.7c-.72.11-2.45.17-4.55-2.39-2.57-3.13-2.31-7.62-2.48-8.77A40.79,40.79,0,0,0,62.27,319c-.63-1.71-.47-2.69-.28-2.81s1.75.46,2.58,2.48,2.6,3.89,2.89,6.86.15,7.23,1.79,9,3.43,1.33,3,2.15A15.54,15.54,0,0,1,70.39,336.7Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.82,383.8s-2.48-8,5.26-22.61,14.76-19,14.76-19-.07,8.13-6.87,21.63S72.86,383.2,71.82,383.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.05,348.45c.23-.42.32,0,.1.4-2.75,5.18-12.24,20.8-15.3,31.57-.13.45-.5,0-.35-.46C78.5,361.8,85.26,353.72,88.05,348.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,370.58s.52-10.19-2.27-12.77-3.39-1.91-4.21-2.11a7.73,7.73,0,0,0-2.88.55s4.22.95,5.18,3.82Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,370.58s.52-10.19-2.27-12.77-3.39-1.91-4.21-2.11a7.73,7.73,0,0,0-2.88.55s4.22.95,5.18,3.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,373.68a6.69,6.69,0,0,1,.9,4.63c-2.27,22-7.87,33.7-17.05,48,0,0-1.81,4.62.45,3.58,0,0,14.48-15.3,18.25-50.53,0,0,.17-4,2.78-5.7C101.08,373.67,96.18,372.5,95.75,373.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,351.72a2.45,2.45,0,0,1,2.56,2.14c.54,2.36,4.81,15.16,3,18.84S98,374.8,96.38,375c-1.77.26-5.6-2.31-6.25-4.4s-1.77-6.38-1.43-8.83S88.35,351.8,95,351.72Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,351.72a2.45,2.45,0,0,1,2.56,2.14c.54,2.36,4.81,15.16,3,18.84S98,374.8,96.38,375c-1.77.26-5.6-2.31-6.25-4.4s-1.77-6.38-1.43-8.83S88.35,351.8,95,351.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17,350.47s2.11,1.78,2.19,3.8,1.15,11-1.17,15.41-4.26,5.63-7.51,5.61,2.47-22.6,2.47-22.6S105,349.21,106.17,350.47Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17,350.47s2.11,1.78,2.19,3.8,1.15,11-1.17,15.41-4.26,5.63-7.51,5.61,2.47-22.6,2.47-22.6S105,349.21,106.17,350.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6,351.75s3.19.15,4.36,2.52a19.23,19.23,0,0,1,1.69,10.16c-.54,3.43-1.27,11.83-8.63,10.83-5.56-.76-6.78-8.26-6.51-14.46.19-4.55,3-5.25,4.58-6.88A7,7,0,0,1,101.6,351.75Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.94,375.18s-6.13.88-8.82-2.85-1.79-6.38-2.24-9a17.16,17.16,0,0,0-1.45-4.57s1.68.81,3,5.85S95,374.72,98.94,375.18Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,429.21s2.66-11.29,14-21.94c10.81-10.2,17.61-10.51,19.55-11.52l.23-.14c1.57-1.13-7.18,11-14.77,17.88S85.34,426.81,80.12,429.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54,402.35C96,408.47,89.17,416.2,83.29,424.84c-.27.4-.55,1.22-.28.83a100.44,100.44,0,0,1,22.3-22.83C105.69,402.55,105.94,402.1,105.54,402.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,355.54s4.87-1.73,6.12-6.29.74-8.54-.81-11.36-2.35-2.95-2.35-2.95-2.37-1.09-5.47,3.64-5.93,8.65-5,11.86C52.2,356.58,57.81,355.54,57.81,355.54Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,355.54s4.87-1.73,6.12-6.29.74-8.54-.81-11.36-2.35-2.95-2.35-2.95-2.37-1.09-5.47,3.64-5.93,8.65-5,11.86C52.2,356.58,57.81,355.54,57.81,355.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.53,360.31s-.92,0-2,4c-1,3.84-5.43,30.78,4.83,53.35,0,0,.94,3.86-2.61,3.21,0,0-10.93-26.28-4.45-57.11a5.62,5.62,0,0,0-.91-3.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.49,350.83S69.55,347,69,343.15s-1.64-4.17-2-4.36-2.67-.23-4.46,2.73-2.46,5.23-2.36,6.71,1.91,3.12,1.91,3.12A4.5,4.5,0,0,0,66.49,350.83Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.49,350.83S69.55,347,69,343.15s-1.64-4.17-2-4.36-2.67-.23-4.46,2.73-2.46,5.23-2.36,6.71,1.91,3.12,1.91,3.12A4.5,4.5,0,0,0,66.49,350.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11,341.65s1.65,1,1.23,4.26a21.82,21.82,0,0,1-2.6,7.22c-.38.61-2.85,6.76-6.93,8.26s-4.22-.26-4.22-.26a7.12,7.12,0,0,1-1.27-6.21,25.67,25.67,0,0,1,3.88-9.17c1.73-2.43,2.56-3.84,4.7-4.24S68.57,341.1,69.11,341.65Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11,341.65s1.65,1,1.23,4.26a21.82,21.82,0,0,1-2.6,7.22c-.38.61-2.85,6.76-6.93,8.26s-4.22-.26-4.22-.26a7.12,7.12,0,0,1-1.27-6.21,25.67,25.67,0,0,1,3.88-9.17c1.73-2.43,2.56-3.84,4.7-4.24S68.57,341.1,69.11,341.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,361.14s3.78,1.86,6.68-3.49,2.12-7.63,2.11-8.52.58-1.66.26-2.84-.81-1.08-1.2-2.63,0-3.57-.52-4.31a2.79,2.79,0,0,0-1.93-1.46,21.88,21.88,0,0,0-3.81.37c-1.08.06-1.35,2-2.23,2.57s-3.41,2.29-4,6.85-.93,7.65.49,9.88S52.67,360.76,54,361.14Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,362.59c.65.32,2.28.89,5.05-.94,3.38-2.23,4.45-6.6,4.94-7.65a42,42,0,0,1,3-6c1.1-1.45,1.23-2.43,1.09-2.6s-1.81-.08-3.19,1.62S67,350,65.8,352.74s-2.27,6.87-4.36,8.08-3.66.26-3.5,1.17A14,14,0,0,0,59.71,362.59Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.74,406.2s2.48-8-5.27-22.61-14.76-19-14.76-19,.08,8.13,6.88,21.63S55.7,405.6,56.74,406.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,370.84c-.22-.41-.31,0-.09.41,2.74,5.18,12.23,20.79,15.29,31.57.13.45.5,0,.36-.46C50.05,384.2,43.29,376.11,40.5,370.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.59 462.77 112.81 462.77 109.71 429.31 109.03 421.93 46.37 421.93 45.69 429.31 42.59 462.77",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.9 426.95 109.71 429.31 109.03 421.93 46.37 421.93 45.9 426.95",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.35,
    y: 415.66,
    width: 70.69,
    height: 8.89,
    transform: "translate(155.39 840.2) rotate(180)",
    style: {
      fill: "#523BD0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.06,
    y: 55.48,
    width: 331.88,
    height: 242.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.94,298.43l-331.88.15h-.15v-.15l-.1-242.95v-.25h.25l331.88.15h.11v.1Zm0,0-.11-242.95.11.11-331.88.14.25-.25-.1,243-.15-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.06,
    y: 55.48,
    width: 331.88,
    height: 9.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.08,60.16a1.89,1.89,0,1,1-1.89-1.89A1.89,1.89,0,0,1,93.08,60.16Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.77,60.16a1.89,1.89,0,1,1-1.89-1.89A1.89,1.89,0,0,1,100.77,60.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46,60.16a1.89,1.89,0,1,1-1.89-1.89A1.89,1.89,0,0,1,108.46,60.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2,115a1.43,1.43,0,0,1-.9,1.8,2,2,0,0,1-.56.08h0a1.8,1.8,0,0,1-1-.29,2.43,2.43,0,0,1-.82-.89,6.91,6.91,0,0,1-.54-3.08,2.18,2.18,0,0,0-.31-1.1,2.31,2.31,0,0,0-.77-.75,4.77,4.77,0,0,0-1.43-.61h-3v5.56a1.43,1.43,0,0,1-1.44,1.41,1.41,1.41,0,0,1-1.41-1.41V100.61a1.39,1.39,0,0,1,1.41-1.41H123a5.48,5.48,0,0,1,3.48,9.72,3.9,3.9,0,0,1,.9,1,4.87,4.87,0,0,1,.85,2.77,6.28,6.28,0,0,0,.1,1.51A1.41,1.41,0,0,1,129.2,115Zm-3.59-10.31a2.64,2.64,0,0,0-2.64-2.66h-3.16v5.28H123A2.63,2.63,0,0,0,125.61,104.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.35,115.74V100.61a1.39,1.39,0,0,1,1.41-1.41h8.39a1.42,1.42,0,0,1,1.41,1.41,1.45,1.45,0,0,1-1.41,1.44h-7v4.69h6a1.43,1.43,0,0,1,0,2.85h-6v4.72h7a1.42,1.42,0,0,1,0,2.84h-8.31c-.05,0-.05,0-.05,0l0,0A1.41,1.41,0,0,1,133.35,115.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,112.69a1.34,1.34,0,0,1,1.87-.18,8.44,8.44,0,0,0,4.9,2,5.55,5.55,0,0,0,3.2-.95,2.33,2.33,0,0,0,1.11-1.85,1.51,1.51,0,0,0-.23-.82,2.54,2.54,0,0,0-.77-.77,10.41,10.41,0,0,0-3.52-1.21h-.05a14.08,14.08,0,0,1-3.31-1,5.48,5.48,0,0,1-2.38-2,3.87,3.87,0,0,1-.59-2.1,4.76,4.76,0,0,1,2.05-3.75,7.6,7.6,0,0,1,4.44-1.35,10,10,0,0,1,5.59,2,1.32,1.32,0,0,1,.36,1.82,1.3,1.3,0,0,1-1.82.38,7.47,7.47,0,0,0-4.13-1.64,5,5,0,0,0-2.88.87,2.05,2.05,0,0,0-1,1.62,1.24,1.24,0,0,0,.18.72,2.59,2.59,0,0,0,.69.66A8.58,8.58,0,0,0,155,106.3H155a15.17,15.17,0,0,1,3.54,1.08,6,6,0,0,1,2.56,2.13,4.09,4.09,0,0,1,.62,2.18,4.94,4.94,0,0,1-2.21,4,8,8,0,0,1-4.74,1.47,11.06,11.06,0,0,1-6.57-2.57A1.36,1.36,0,0,1,148,112.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.67,115.74V100.61a1.38,1.38,0,0,1,1.41-1.41h8.39a1.42,1.42,0,0,1,1.41,1.41,1.45,1.45,0,0,1-1.41,1.44h-6.95v4.69h6a1.43,1.43,0,0,1,0,2.85h-6v4.72h6.95a1.42,1.42,0,0,1,0,2.84h-8.31c-.06,0-.06,0-.06,0l0,0A1.4,1.4,0,0,1,165.67,115.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,102.05h-4.08v13.69a1.41,1.41,0,0,1-2.82,0V102.05H180.9a1.43,1.43,0,0,1-1.41-1.44,1.39,1.39,0,0,1,1.41-1.41h11a1.4,1.4,0,0,1,1.41,1.41A1.45,1.45,0,0,1,191.86,102.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.32,136.89h-3.15v5.57a1.43,1.43,0,0,1-2.85,0V127.32a1.41,1.41,0,0,1,1.41-1.41h4.59a5.49,5.49,0,1,1,0,11ZM120.17,134h3.15a2.64,2.64,0,1,0,0-5.28h-3.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.64,139.64H133.4L132.15,143a1.43,1.43,0,0,1-2.67-1l5.67-15.1a1.42,1.42,0,0,1,1.36-.9,1.4,1.4,0,0,1,1.36.9l5.67,15.1a1.47,1.47,0,0,1-.85,1.85,1.44,1.44,0,0,1-.49.08,1.4,1.4,0,0,1-1.31-.9Zm-1-2.83-2.08-5.51-2.08,5.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,139.4a1.34,1.34,0,0,1,1.87-.18,8.31,8.31,0,0,0,4.9,2,5.58,5.58,0,0,0,3.21-.95,2.29,2.29,0,0,0,1.1-1.85,1.51,1.51,0,0,0-.23-.82,2.66,2.66,0,0,0-.77-.77,10.43,10.43,0,0,0-3.52-1.2h-.05a14.08,14.08,0,0,1-3.31-1,5.54,5.54,0,0,1-2.38-2,3.92,3.92,0,0,1-.59-2.11,4.74,4.74,0,0,1,2.05-3.74,7.61,7.61,0,0,1,4.44-1.36,10.1,10.1,0,0,1,5.59,2,1.32,1.32,0,0,1,.36,1.82,1.29,1.29,0,0,1-1.82.39,7.47,7.47,0,0,0-4.13-1.64,4.89,4.89,0,0,0-2.87.87,2,2,0,0,0-1,1.61,1.22,1.22,0,0,0,.18.72,2.45,2.45,0,0,0,.69.67A8.94,8.94,0,0,0,153,133h.05a15.17,15.17,0,0,1,3.54,1.07,6,6,0,0,1,2.56,2.13,4.14,4.14,0,0,1,.62,2.18,4.94,4.94,0,0,1-2.21,4,8,8,0,0,1-4.74,1.46,11.08,11.08,0,0,1-6.57-2.56A1.37,1.37,0,0,1,146.05,139.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9,139.4a1.34,1.34,0,0,1,1.87-.18,8.31,8.31,0,0,0,4.9,2,5.58,5.58,0,0,0,3.21-.95,2.29,2.29,0,0,0,1.1-1.85,1.51,1.51,0,0,0-.23-.82,2.66,2.66,0,0,0-.77-.77,10.36,10.36,0,0,0-3.51-1.2h-.06a13.86,13.86,0,0,1-3.3-1,5.51,5.51,0,0,1-2.39-2,4,4,0,0,1-.59-2.11,4.74,4.74,0,0,1,2.05-3.74,7.61,7.61,0,0,1,4.44-1.36,10.1,10.1,0,0,1,5.59,2,1.32,1.32,0,0,1,.36,1.82,1.29,1.29,0,0,1-1.82.39,7.47,7.47,0,0,0-4.13-1.64,4.92,4.92,0,0,0-2.87.87,2,2,0,0,0-1,1.61,1.22,1.22,0,0,0,.18.72,2.45,2.45,0,0,0,.69.67,9,9,0,0,0,3.21,1.13h.05a15.17,15.17,0,0,1,3.54,1.07,6.06,6.06,0,0,1,2.57,2.13,4.22,4.22,0,0,1,.61,2.18,5,5,0,0,1-2.2,4,8.07,8.07,0,0,1-4.75,1.46,11.08,11.08,0,0,1-6.57-2.56A1.37,1.37,0,0,1,162.9,139.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.58,128l-6.29,15a.68.68,0,0,1-.12.24l0,0a1.53,1.53,0,0,1-.13.16c0,.05,0,.05,0,.07a1,1,0,0,0-.18.13h0c-.08,0-.13.13-.23.15h0s0,0,0,0a1.23,1.23,0,0,0-.21.05h0a.64.64,0,0,1-.25,0,.66.66,0,0,1-.24,0h-.07a1,1,0,0,0-.18-.05s0,0-.05,0a.44.44,0,0,1-.23-.15h0l-.18-.13,0-.07c0-.06-.08-.11-.1-.16s-.05,0-.05,0a.66.66,0,0,1-.11-.24l-3.36-8L188,143a1.33,1.33,0,0,1-.1.24,0,0,0,0,0,0,0l-.16.16c0,.05,0,.05,0,.07a.65.65,0,0,0-.16.13h-.05c-.08,0-.15.13-.2.15h0a0,0,0,0,0,0,0,.44.44,0,0,0-.2.05h-.08a.61.61,0,0,1-.23,0,.77.77,0,0,1-.26,0h-.07a1,1,0,0,0-.18-.05s0,0-.05,0a.61.61,0,0,1-.23-.15h0c-.08-.05-.1-.1-.18-.13l0-.07c-.05-.06-.08-.11-.13-.16v0a2.6,2.6,0,0,1-.13-.24l-6.31-15a1.39,1.39,0,0,1,.77-1.82,1.37,1.37,0,0,1,1.82.74l5,11.88L190,131a1.41,1.41,0,0,1,1.33-.88,1.48,1.48,0,0,1,1.34.88l3.31,7.87L201,127a1.43,1.43,0,0,1,1.87-.74A1.38,1.38,0,0,1,203.58,128Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.45,128.14a9.4,9.4,0,0,1,0,13,8.39,8.39,0,0,1-6.13,2.75,8.64,8.64,0,0,1-6.28-2.75,9.56,9.56,0,0,1,0-13,8.55,8.55,0,0,1,6.28-2.74A8.31,8.31,0,0,1,221.45,128.14Zm-.33,6.49a6.66,6.66,0,0,0-1.74-4.49,5.54,5.54,0,0,0-8.21,0,6.52,6.52,0,0,0-1.74,4.49,6.42,6.42,0,0,0,1.74,4.47,5.5,5.5,0,0,0,8.21,0A6.56,6.56,0,0,0,221.12,134.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,141.74a1.4,1.4,0,0,1-.9,1.79,2,2,0,0,1-.56.08h0a1.88,1.88,0,0,1-1-.28,2.64,2.64,0,0,1-.82-.9,6.88,6.88,0,0,1-.54-3.08,2.11,2.11,0,0,0-.3-1.1,2.38,2.38,0,0,0-.77-.74,4.89,4.89,0,0,0-1.44-.62h-3v5.57a1.43,1.43,0,0,1-1.43,1.41,1.4,1.4,0,0,1-1.41-1.41V127.32a1.39,1.39,0,0,1,1.41-1.41h4.59a5.49,5.49,0,0,1,5.49,5.52,5.42,5.42,0,0,1-2,4.2,4.3,4.3,0,0,1,.9,1,4.91,4.91,0,0,1,.84,2.77,7,7,0,0,0,.1,1.52A1.33,1.33,0,0,1,241,141.74Zm-3.59-10.31a2.64,2.64,0,0,0-2.64-2.67h-3.16V134h3.16A2.63,2.63,0,0,0,237.38,131.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.13,142.46V127.32a1.39,1.39,0,0,1,1.41-1.41h3a9,9,0,0,1,0,18h-3A1.4,1.4,0,0,1,245.13,142.46ZM248,141h1.59a6.13,6.13,0,0,0,0-12.26H248Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.24,169.32v4.81a.2.2,0,0,1-.4,0v-5.39a.21.21,0,0,1,.07-.23.23.23,0,0,1,.29.05l3.56,4.94v-4.78a.21.21,0,1,1,.41,0v5.41a.2.2,0,0,1-.21.2.19.19,0,0,1-.16-.08s0,0,0,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.9,172.28a2,2,0,0,1,4-.15h0v0a.19.19,0,0,1-.2.19H123.3a1.63,1.63,0,0,0,1.6,1.58,1.54,1.54,0,0,0,1.32-.75.2.2,0,0,1,.27-.07.21.21,0,0,1,.07.29,2,2,0,0,1-1.66.93A2,2,0,0,1,122.9,172.28Zm.43-.33h3.11a1.58,1.58,0,0,0-1.54-1.33A1.6,1.6,0,0,0,123.33,172Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.47,174.3a.2.2,0,0,1-.08-.1l-1.54-3.67a.19.19,0,0,1,.1-.26.2.2,0,0,1,.26.11l1.36,3.24,1-2.26a.22.22,0,0,1,.4,0l1,2.26,1.35-3.24a.22.22,0,0,1,.27-.11.19.19,0,0,1,.1.26l-1.53,3.66a.25.25,0,0,1-.08.1.18.18,0,0,1-.1,0h0a.2.2,0,0,1-.16-.13h0l-.95-2.27-.95,2.27h0a.2.2,0,0,1-.18.13l-.07,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.94,168.66a.2.2,0,0,1,.2-.2h1.66a1.67,1.67,0,1,1,0,3.34l-1.45,0v2.31a.2.2,0,0,1-.21.2.2.2,0,0,1-.2-.2Zm1.86,2.75a1.29,1.29,0,0,0,1.27-1.28,1.27,1.27,0,0,0-1.27-1.26h-1.45v2.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.19,170.42v3.71a.2.2,0,1,1-.4,0v-.61a2,2,0,0,1-1.55.81,2.06,2.06,0,0,1,0-4.11,2,2,0,0,1,1.55.8v-.6a.2.2,0,0,1,.4,0Zm-.4,1.85a1.55,1.55,0,1,0-1.55,1.66A1.61,1.61,0,0,0,145.79,172.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.65,173.47a.2.2,0,0,1,.29,0,2.16,2.16,0,0,0,1.25.48,1.23,1.23,0,0,0,.79-.26.61.61,0,0,0,.31-.5.65.65,0,0,0-.3-.5,1.86,1.86,0,0,0-.87-.3h0a2.37,2.37,0,0,1-.93-.32.85.85,0,0,1-.44-.74,1,1,0,0,1,.44-.81,1.83,1.83,0,0,1,1-.27,2.2,2.2,0,0,1,1.22.44.21.21,0,0,1,.06.29.2.2,0,0,1-.27.06,1.79,1.79,0,0,0-1-.42,1.23,1.23,0,0,0-.78.24.6.6,0,0,0-.26.47.48.48,0,0,0,.23.41,2,2,0,0,0,.84.29h0a2.74,2.74,0,0,1,1,.33,1,1,0,0,1,0,1.67,1.69,1.69,0,0,1-1,.33,2.46,2.46,0,0,1-1.51-.59A.18.18,0,0,1,147.65,173.47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.7,173.47a.19.19,0,0,1,.28,0,2.22,2.22,0,0,0,1.26.48,1.18,1.18,0,0,0,.78-.26.61.61,0,0,0,.31-.5.64.64,0,0,0-.29-.5,1.9,1.9,0,0,0-.87-.3h0a2.31,2.31,0,0,1-.93-.32.86.86,0,0,1-.45-.74,1,1,0,0,1,.45-.81,1.82,1.82,0,0,1,1-.27,2.23,2.23,0,0,1,1.23.44.21.21,0,0,1-.22.35,1.73,1.73,0,0,0-1-.42,1.27,1.27,0,0,0-.78.24.63.63,0,0,0-.26.47.49.49,0,0,0,.24.41,2,2,0,0,0,.84.29h0a2.63,2.63,0,0,1,1,.33,1,1,0,0,1,.46.84,1,1,0,0,1-.46.83,1.71,1.71,0,0,1-1,.33,2.52,2.52,0,0,1-1.52-.59A.19.19,0,0,1,151.7,173.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.36,174.3a.2.2,0,0,1-.08-.1l-1.54-3.67a.19.19,0,0,1,.1-.26.2.2,0,0,1,.26.11l1.36,3.24.95-2.26a.22.22,0,0,1,.4,0l.95,2.26,1.35-3.24a.21.21,0,0,1,.26-.11.19.19,0,0,1,.11.26L160,174.19a.25.25,0,0,1-.08.1.18.18,0,0,1-.1,0h0a.2.2,0,0,1-.16-.13h0l-.95-2.27-1,2.27h0a.2.2,0,0,1-.18.13l-.07,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.76,170.22a2.06,2.06,0,1,1-1.95,2.05A2,2,0,0,1,164.76,170.22Zm0,3.71a1.66,1.66,0,1,0-1.54-1.66A1.61,1.61,0,0,0,164.76,173.93Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.09,170.43a.2.2,0,0,1,.21-.2.19.19,0,0,1,.19.2v.9l.06-.1a2,2,0,0,1,1.64-1,.19.19,0,0,1,.2.2.2.2,0,0,1-.2.2,1.48,1.48,0,0,0-1.19.67,3.29,3.29,0,0,0-.49,1,.1.1,0,0,0,0,.06v1.81a.2.2,0,0,1-.19.2.2.2,0,0,1-.21-.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.85,173.53a2,2,0,0,1-1.58.8,2.06,2.06,0,0,1,0-4.11,2,2,0,0,1,1.58.8v-2.36a.2.2,0,0,1,.21-.2.2.2,0,0,1,.2.2v5.47a.2.2,0,0,1-.2.2.2.2,0,0,1-.21-.2Zm0-1.18v-.14a1.64,1.64,0,1,0,0,.14Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.27,
    y: 178.57,
    width: 146.98,
    height: 16.08,
    style: {
      fill: "#ebebeb"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.61,202.34a3.11,3.11,0,0,1,1.9.65.21.21,0,0,1,0,.29.2.2,0,0,1-.29,0,2.67,2.67,0,0,0-1.64-.57,2.57,2.57,0,1,0,0,5.14,2.51,2.51,0,0,0,1.63-.57.22.22,0,0,1,.27.34,3.11,3.11,0,0,1-1.9.64,3,3,0,1,1,0-6Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.86,204.19a2.06,2.06,0,1,1-1.94,2.05A2,2,0,0,1,124.86,204.19Zm0,3.71a1.66,1.66,0,1,0-1.54-1.66A1.62,1.62,0,0,0,124.86,207.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.3,205.87A1.27,1.27,0,0,0,130,204.6a1.29,1.29,0,0,0-1.28,1.27v2.26s0,.07,0,.09a.18.18,0,0,1-.15.08h-.05a.21.21,0,0,1-.13-.11,0,0,0,0,1,0,0h0V204.4a.19.19,0,0,1,.2-.2.19.19,0,0,1,.19.2v.39a1.67,1.67,0,0,1,2.95,1.08v2.23a.2.2,0,1,1-.4,0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.32,202.64a.21.21,0,0,1-.2.2c-.29,0-.44.06-.52.16a1,1,0,0,0-.17.68v.44H135a.21.21,0,1,1,0,.41h-.58v3.58a.21.21,0,0,1-.2.2.21.21,0,0,1-.21-.2v-3.58h-.55a.2.2,0,0,1-.2-.21.2.2,0,0,1,.2-.2H134v-.44a1.4,1.4,0,0,1,.26-1,1.12,1.12,0,0,1,.84-.3A.22.22,0,0,1,135.32,202.64Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.55,203.05a.21.21,0,1,1,.41,0v.19a.21.21,0,1,1-.41,0Zm0,1.34a.19.19,0,0,1,.2-.2.2.2,0,0,1,.21.2v3.71a.2.2,0,0,1-.21.2.2.2,0,0,1-.2-.2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.9,204.4a.2.2,0,0,1,.21-.2.2.2,0,0,1,.2.2v.9a.93.93,0,0,1,.05-.1,2,2,0,0,1,1.65-1,.19.19,0,0,1,.2.2.2.2,0,0,1-.2.2,1.47,1.47,0,0,0-1.19.67,3.68,3.68,0,0,0-.5,1,.18.18,0,0,0,0,.06v1.81a.21.21,0,0,1-.41,0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.47,205.87a1.3,1.3,0,0,0-1.28-1.28,1.28,1.28,0,0,0-1.26,1.28v2.28h0a.22.22,0,0,1-.1.11.19.19,0,0,1-.1,0h-.06l0,0,0,0,0,0h0s0,0,0,0v-.07h0v-2.24a1.27,1.27,0,1,0-2.54,0v2.24a.19.19,0,0,1-.09.16l0,0h-.08a.22.22,0,0,1-.17-.15v-3.76a.19.19,0,0,1,.19-.19.19.19,0,0,1,.2.19v.39a1.64,1.64,0,0,1,1.27-.58,1.67,1.67,0,0,1,1.47.87,1.7,1.7,0,0,1,1.47-.87,1.66,1.66,0,0,1,1.67,1.67v2.24a.19.19,0,0,1-.2.19.19.19,0,0,1-.19-.19Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61,203.29v4.81a.2.2,0,0,1-.4,0v-5.39a.21.21,0,0,1,.07-.23.23.23,0,0,1,.29.05l3.56,4.94v-4.78a.21.21,0,1,1,.41,0v5.41a.2.2,0,0,1-.21.2.19.19,0,0,1-.16-.08s0,0,0,0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.27,206.25a2,2,0,0,1,4-.15h0v0a.2.2,0,0,1-.2.19h-3.38a1.62,1.62,0,0,0,1.6,1.58,1.54,1.54,0,0,0,1.32-.75.2.2,0,0,1,.27-.07.22.22,0,0,1,.07.29,2,2,0,0,1-1.66.93A2,2,0,0,1,159.27,206.25Zm.43-.33h3.11a1.58,1.58,0,0,0-1.54-1.33A1.6,1.6,0,0,0,159.7,205.92Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M165.84,208.27a.2.2,0,0,1-.08-.1l-1.54-3.67a.19.19,0,0,1,.1-.26.2.2,0,0,1,.26.11l1.36,3.24.95-2.26a.22.22,0,0,1,.4,0l.94,2.26,1.36-3.24a.21.21,0,0,1,.26-.11.19.19,0,0,1,.11.26l-1.53,3.66a.25.25,0,0,1-.08.1.21.21,0,0,1-.1,0h0a.2.2,0,0,1-.16-.13h0l-.95-2.27-1,2.27h0a.2.2,0,0,1-.18.13l-.07,0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.31,202.63a.2.2,0,0,1,.2-.2h1.66a1.67,1.67,0,1,1,0,3.34l-1.45,0v2.31a.2.2,0,0,1-.21.2.2.2,0,0,1-.2-.2Zm1.86,2.75a1.29,1.29,0,0,0,1.27-1.28,1.27,1.27,0,0,0-1.27-1.26h-1.45v2.54Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.56,204.39v3.71a.21.21,0,0,1-.41,0v-.61a1.92,1.92,0,0,1-1.54.81,2.06,2.06,0,0,1,0-4.11,1.91,1.91,0,0,1,1.54.8v-.6a.2.2,0,0,1,.21-.2A.2.2,0,0,1,182.56,204.39Zm-.41,1.85a1.54,1.54,0,1,0-1.54,1.66A1.6,1.6,0,0,0,182.15,206.24Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M184,207.44a.2.2,0,0,1,.29,0,2.16,2.16,0,0,0,1.25.48,1.18,1.18,0,0,0,.78-.26.59.59,0,0,0,.31-.5.61.61,0,0,0-.29-.5,1.9,1.9,0,0,0-.87-.3h0a2.37,2.37,0,0,1-.93-.32.85.85,0,0,1-.44-.74,1,1,0,0,1,.44-.81,1.83,1.83,0,0,1,1-.27,2.2,2.2,0,0,1,1.22.44.22.22,0,0,1,.06.29.22.22,0,0,1-.28.06,1.73,1.73,0,0,0-1-.42,1.23,1.23,0,0,0-.78.24.6.6,0,0,0-.26.47.48.48,0,0,0,.23.41,2,2,0,0,0,.84.29h0a2.74,2.74,0,0,1,1,.33,1,1,0,0,1,0,1.67,1.69,1.69,0,0,1-1,.33,2.46,2.46,0,0,1-1.51-.59A.18.18,0,0,1,184,207.44Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M188.07,207.44a.19.19,0,0,1,.28,0,2.22,2.22,0,0,0,1.26.48,1.18,1.18,0,0,0,.78-.26.61.61,0,0,0,.31-.5.64.64,0,0,0-.29-.5,1.91,1.91,0,0,0-.88-.3h0a2.31,2.31,0,0,1-.93-.32.86.86,0,0,1-.45-.74,1,1,0,0,1,.45-.81,1.8,1.8,0,0,1,1-.27,2.23,2.23,0,0,1,1.23.44.22.22,0,0,1,.06.29.22.22,0,0,1-.28.06,1.73,1.73,0,0,0-1-.42,1.27,1.27,0,0,0-.78.24.63.63,0,0,0-.26.47.49.49,0,0,0,.24.41,2,2,0,0,0,.84.29h0a2.62,2.62,0,0,1,1,.33,1,1,0,0,1,0,1.67,1.66,1.66,0,0,1-1,.33,2.52,2.52,0,0,1-1.52-.59A.19.19,0,0,1,188.07,207.44Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M193.73,208.27a.2.2,0,0,1-.08-.1l-1.55-3.67a.2.2,0,1,1,.37-.15l1.36,3.24.95-2.26a.22.22,0,0,1,.19-.13.23.23,0,0,1,.21.13l.94,2.26,1.36-3.24a.21.21,0,0,1,.26-.11.2.2,0,0,1,.11.26l-1.53,3.66a.39.39,0,0,1-.08.1.21.21,0,0,1-.1,0h0a.2.2,0,0,1-.16-.13h0l-1-2.27-.94,2.27h0a.2.2,0,0,1-.18.13l-.07,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.13,204.19a2.06,2.06,0,1,1-1.95,2.05A2,2,0,0,1,201.13,204.19Zm0,3.71a1.66,1.66,0,1,0-1.55-1.66A1.61,1.61,0,0,0,201.13,207.9Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.45,204.4a.2.2,0,0,1,.21-.2.2.2,0,0,1,.2.2v.9a.37.37,0,0,1,.06-.1,2,2,0,0,1,1.64-1,.19.19,0,0,1,.2.2.2.2,0,0,1-.2.2,1.47,1.47,0,0,0-1.19.67,3.68,3.68,0,0,0-.5,1,.18.18,0,0,0,0,.06v1.81a.21.21,0,0,1-.41,0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M211.22,207.5a2,2,0,0,1-1.58.8,2.06,2.06,0,0,1,0-4.11,2,2,0,0,1,1.58.8v-2.36a.2.2,0,0,1,.21-.2.2.2,0,0,1,.2.2v5.47a.2.2,0,0,1-.2.2.2.2,0,0,1-.21-.2Zm0-1.18v-.14a1.64,1.64,0,1,0,0,.14Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.27,
    y: 212.54,
    width: 146.98,
    height: 16.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.07,154.23v26.86h-7.6V154.23c0-10.22-7.76-18.53-17.3-18.53s-17.31,8.31-17.31,18.53v26.86h-7.59V154.23c0-14.63,11.17-26.53,24.9-26.53S351.07,139.6,351.07,154.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.27 161.21 308.86 161.52 308.86 181.09 301.27 181.09 301.27 161.21",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.06 163.24 351.06 181.09 343.47 181.09 343.47 162.93 351.06 163.24",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.54,
    y: 171.15,
    width: 69.26,
    height: 57.48,
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.54,
    y: 171.15,
    width: 34.63,
    height: 57.48,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,199.51l2.9,13.76H320l2.9-13.76a6.16,6.16,0,1,1,6.51,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.17,175l-3.1-.5A23.45,23.45,0,0,0,340.67,159l-2.78-1.46A26.59,26.59,0,0,1,387.17,175Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.24,175.09l.12-.71a22.73,22.73,0,0,0-42.07-15l-.35.59-4.05-2.13.38-.65a27.31,27.31,0,0,1,50.61,18l-.12.71ZM366,147.17a24.17,24.17,0,0,1,18.87,26.73l1.68.27a25.86,25.86,0,0,0-47.66-16.95l1.5.79A24.14,24.14,0,0,1,366,147.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.44 172.22 381.88 171.09 385.28 175.65 389.57 172 390.62 173.43 384.88 178.3 380.44 172.22",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.76,179.35l-5.31-7.26,2.56-2,3.39,4.53,4.28-3.64,1.92,2.58Zm-3.33-7,3.58,4.89,4.64-3.94-.2-.26-4.29,3.64-3.42-4.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.42,167.26l3.1.5a23.45,23.45,0,0,0,43.4,15.53l2.78,1.46a26.59,26.59,0,0,1-49.28-17.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.92,198.14a27.29,27.29,0,0,1-21.2-31l.11-.71,4.52.72-.12.71a22.73,22.73,0,0,0,42.07,15.06l.35-.6,4.05,2.13-.38.65A27.23,27.23,0,0,1,354.92,198.14Zm-19.89-30A25.87,25.87,0,0,0,382.7,185l-1.51-.79a24.17,24.17,0,0,1-44.48-15.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.15 170.03 339.71 171.16 336.31 166.6 332.03 170.25 330.97 168.82 336.71 163.95 341.15 170.03",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.91,171.29,330,168.71l6.84-5.81,5.31,7.26-2.56,2-3.38-4.53Zm0-2.35.2.26,4.28-3.64,3.42,4.58.31-.25L336.58,165Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,184.46a9.59,9.59,0,0,1-4.3,4.3,8.31,8.31,0,0,1,1.79-2.5A8.51,8.51,0,0,1,127.43,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,184.46a8.59,8.59,0,0,1,2.5,1.8,8.33,8.33,0,0,1,1.8,2.5,9.46,9.46,0,0,1-4.3-4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,186.61a8.77,8.77,0,0,1-3,.5,8.47,8.47,0,0,1-3-.5,8.26,8.26,0,0,1,3-.5A8.54,8.54,0,0,1,128.32,186.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28,183.57a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.91,184.46a8.46,8.46,0,0,1-1.8,2.5,8.33,8.33,0,0,1-2.5,1.8,9.59,9.59,0,0,1,4.3-4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.61,184.46a9.59,9.59,0,0,1,4.3,4.3,8.33,8.33,0,0,1-2.5-1.8A8.46,8.46,0,0,1,133.61,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,186.61a8.73,8.73,0,0,1-3,.5,8.51,8.51,0,0,1-3-.5,8.29,8.29,0,0,1,3-.5A8.51,8.51,0,0,1,138.8,186.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76,183.57a8.73,8.73,0,0,1,.5,3,8.54,8.54,0,0,1-.5,3,8.33,8.33,0,0,1-.5-3A8.73,8.73,0,0,1,135.76,183.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.39,184.46a8.62,8.62,0,0,1-1.79,2.5,8.51,8.51,0,0,1-2.51,1.8,8.33,8.33,0,0,1,1.8-2.5A8.59,8.59,0,0,1,148.39,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09,184.46a8.51,8.51,0,0,1,2.51,1.8,8.31,8.31,0,0,1,1.79,2.5,9.59,9.59,0,0,1-4.3-4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28,186.61a8.7,8.7,0,0,1-3,.5,8.54,8.54,0,0,1-3-.5,8.33,8.33,0,0,1,3-.5A8.47,8.47,0,0,1,149.28,186.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,183.57a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.88,184.46a9.59,9.59,0,0,1-4.3,4.3,8.31,8.31,0,0,1,1.79-2.5A8.51,8.51,0,0,1,158.88,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.58,184.46a8.59,8.59,0,0,1,2.5,1.8,8.33,8.33,0,0,1,1.8,2.5,8.51,8.51,0,0,1-2.51-1.8A8.62,8.62,0,0,1,154.58,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.77,186.61a8.77,8.77,0,0,1-3,.5,8.47,8.47,0,0,1-3-.5,8.26,8.26,0,0,1,3-.5A8.54,8.54,0,0,1,159.77,186.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.73,183.57a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.36,184.46a8.46,8.46,0,0,1-1.8,2.5,8.33,8.33,0,0,1-2.5,1.8,8.33,8.33,0,0,1,1.8-2.5A8.46,8.46,0,0,1,169.36,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.06,184.46a9.59,9.59,0,0,1,4.3,4.3,8.33,8.33,0,0,1-2.5-1.8A8.46,8.46,0,0,1,165.06,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,186.61a8.73,8.73,0,0,1-3,.5,8.51,8.51,0,0,1-3-.5,8.29,8.29,0,0,1,3-.5A8.51,8.51,0,0,1,170.25,186.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.21,183.57a8.73,8.73,0,0,1,.5,3,8.33,8.33,0,0,1-.5,3,8.54,8.54,0,0,1-.5-3A8.73,8.73,0,0,1,167.21,183.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,184.46a8.43,8.43,0,0,1-1.79,2.5,8.59,8.59,0,0,1-2.5,1.8,8.14,8.14,0,0,1,1.79-2.5A8.59,8.59,0,0,1,179.84,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.55,184.46a8.59,8.59,0,0,1,2.5,1.8,8.31,8.31,0,0,1,1.79,2.5,8.59,8.59,0,0,1-2.5-1.8A8.43,8.43,0,0,1,175.55,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.73,186.61a8.7,8.7,0,0,1-3,.5,8.45,8.45,0,0,1-3-.5,8.24,8.24,0,0,1,3-.5A8.47,8.47,0,0,1,180.73,186.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.69,183.57a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.33,184.46a9.59,9.59,0,0,1-4.3,4.3,8.31,8.31,0,0,1,1.79-2.5A8.51,8.51,0,0,1,190.33,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,184.46a8.59,8.59,0,0,1,2.5,1.8,8.33,8.33,0,0,1,1.8,2.5,8.51,8.51,0,0,1-2.51-1.8A8.62,8.62,0,0,1,186,184.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.22,186.61a8.77,8.77,0,0,1-3,.5,8.47,8.47,0,0,1-3-.5,8.26,8.26,0,0,1,3-.5A8.54,8.54,0,0,1,191.22,186.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,183.57a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,218.44a8.78,8.78,0,0,1-1.8,2.5,8.59,8.59,0,0,1-2.5,1.8,8.48,8.48,0,0,1,1.79-2.51A8.66,8.66,0,0,1,127.43,218.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,218.44a8.75,8.75,0,0,1,2.5,1.79,8.51,8.51,0,0,1,1.8,2.51,9.46,9.46,0,0,1-4.3-4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,220.59a9.49,9.49,0,0,1-6.08,0,9.49,9.49,0,0,1,6.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28,217.55a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.91,218.44a8.59,8.59,0,0,1-1.8,2.5,8.33,8.33,0,0,1-2.5,1.8,9.46,9.46,0,0,1,4.3-4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.61,218.44a9.46,9.46,0,0,1,4.3,4.3,8.33,8.33,0,0,1-2.5-1.8A8.59,8.59,0,0,1,133.61,218.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,220.59a9.49,9.49,0,0,1-6.08,0,9.49,9.49,0,0,1,6.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76,217.55a8.7,8.7,0,0,1,.5,3,8.54,8.54,0,0,1-.5,3,8.33,8.33,0,0,1-.5-3A8.7,8.7,0,0,1,135.76,217.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.39,218.44a8.75,8.75,0,0,1-1.79,2.5,8.51,8.51,0,0,1-2.51,1.8,8.51,8.51,0,0,1,1.8-2.51A8.75,8.75,0,0,1,148.39,218.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09,218.44a8.66,8.66,0,0,1,2.51,1.79,8.48,8.48,0,0,1,1.79,2.51,8.59,8.59,0,0,1-2.5-1.8A8.78,8.78,0,0,1,144.09,218.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28,220.59a9.49,9.49,0,0,1-6.08,0,9.49,9.49,0,0,1,6.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,217.55a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.88,218.44a8.78,8.78,0,0,1-1.8,2.5,8.59,8.59,0,0,1-2.5,1.8,8.48,8.48,0,0,1,1.79-2.51A8.66,8.66,0,0,1,158.88,218.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.58,218.44a8.75,8.75,0,0,1,2.5,1.79,8.51,8.51,0,0,1,1.8,2.51,8.51,8.51,0,0,1-2.51-1.8A8.75,8.75,0,0,1,154.58,218.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.77,220.59a9.49,9.49,0,0,1-6.08,0,9.49,9.49,0,0,1,6.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.73,217.55a9.49,9.49,0,0,1,0,6.08,9.49,9.49,0,0,1,0-6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.44,
    y: 215.39,
    width: 0.66,
    height: 10.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.55,
    y: 242.11,
    width: 56.99,
    height: 16.45,
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67,250.86a3.13,3.13,0,0,1,3.13-3.08,3.17,3.17,0,0,1,2,.67.5.5,0,0,1,.09.68.5.5,0,0,1-.68.1,2.14,2.14,0,0,0-1.38-.47,2.24,2.24,0,0,0-1.54.61,2.13,2.13,0,0,0-.62,1.49,2.07,2.07,0,0,0,.62,1.48,2.25,2.25,0,0,0,1.54.62,2.16,2.16,0,0,0,1.38-.47.49.49,0,0,1,.59.78,3.16,3.16,0,0,1-2,.66A3.11,3.11,0,0,1,122.67,250.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.06,248.7a3.14,3.14,0,0,1,0,4.32,2.81,2.81,0,0,1-2,.91,2.93,2.93,0,0,1-2.1-.91,3.2,3.2,0,0,1,0-4.32,2.86,2.86,0,0,1,2.1-.92A2.75,2.75,0,0,1,134.06,248.7Zm-.11,2.16a2.24,2.24,0,0,0-.58-1.5,1.86,1.86,0,0,0-1.35-.6,1.88,1.88,0,0,0-1.39.6,2.19,2.19,0,0,0-.58,1.5,2.1,2.1,0,0,0,.58,1.48A1.86,1.86,0,0,0,132,253a1.84,1.84,0,0,0,1.35-.62A2.15,2.15,0,0,0,134,250.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.32,253.46a.47.47,0,1,1-.93,0v-5h0a.45.45,0,0,1,.19-.39.46.46,0,0,1,.64.1L140,252V248.5a.47.47,0,0,1,.47-.46.47.47,0,0,1,.47.46v5a.48.48,0,0,1-.47.47.43.43,0,0,1-.35-.17l0,0-2.73-3.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,248.9h-1.35v4.56a.47.47,0,0,1-.94,0V248.9h-1.35a.47.47,0,0,1-.47-.48.46.46,0,0,1,.47-.47h3.64a.47.47,0,0,1,.47.47A.48.48,0,0,1,146.53,248.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,248.42a.46.46,0,0,1,.47-.47.48.48,0,0,1,.48.47v5a.47.47,0,0,1-.48.47.46.46,0,0,1-.47-.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,253.46a.47.47,0,1,1-.93,0v-5h0a.45.45,0,0,1,.19-.39.47.47,0,0,1,.65.1l2.76,3.82V248.5a.47.47,0,0,1,.93,0v5a.47.47,0,0,1-.47.47.46.46,0,0,1-.35-.17.1.1,0,0,1,0,0L152,249.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.65,253.93a2.46,2.46,0,0,1-2.47-2.47v-3a.46.46,0,0,1,.47-.47.48.48,0,0,1,.48.47v3a1.52,1.52,0,1,0,3,0v-3a.48.48,0,0,1,1,0v3A2.47,2.47,0,0,1,159.65,253.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.69,253.46v-5a.47.47,0,0,1,.47-.47H167a.48.48,0,0,1,0,1h-2.32v1.56h2a.48.48,0,0,1,.47.47.47.47,0,0,1-.47.48h-2V253H167a.47.47,0,0,1,0,.94h-2.8A.47.47,0,0,1,163.69,253.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,250.86a3.13,3.13,0,0,1,3.13-3.08,3.17,3.17,0,0,1,2,.67.5.5,0,0,1,.09.68.5.5,0,0,1-.68.1,2.14,2.14,0,0,0-1.38-.47,2.24,2.24,0,0,0-1.54.61,2.13,2.13,0,0,0-.62,1.49,2.07,2.07,0,0,0,.62,1.48,2.25,2.25,0,0,0,1.54.62,2.16,2.16,0,0,0,1.38-.47.49.49,0,0,1,.59.78,3.16,3.16,0,0,1-2,.66A3.11,3.11,0,0,1,193,250.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,252.52h-2.08l-.42,1.11a.48.48,0,0,1-.44.3.5.5,0,0,1-.17,0,.5.5,0,0,1-.28-.62l1.89-5a.48.48,0,0,1,.45-.3.47.47,0,0,1,.46.3l1.88,5a.48.48,0,0,1-.28.62.39.39,0,0,1-.16,0,.46.46,0,0,1-.44-.3Zm-.35-.94-.7-1.83-.69,1.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,253.46a.47.47,0,1,1-.93,0v-5h0a.45.45,0,0,1,.19-.39.47.47,0,0,1,.65.1l2.76,3.82V248.5a.46.46,0,0,1,.46-.46.47.47,0,0,1,.47.46v5a.47.47,0,0,1-.47.47.43.43,0,0,1-.35-.17.07.07,0,0,1,0,0l-2.74-3.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.58,250.86a3.15,3.15,0,0,1,3.14-3.08,3.19,3.19,0,0,1,2,.67.5.5,0,0,1,.08.68.49.49,0,0,1-.68.1,2.09,2.09,0,0,0-1.37-.47,2.24,2.24,0,0,0-1.54.61,2.09,2.09,0,0,0-.63,1.49,2,2,0,0,0,.63,1.48,2.25,2.25,0,0,0,1.54.62,2.11,2.11,0,0,0,1.37-.47.49.49,0,0,1,.6.78,3.18,3.18,0,0,1-2,.66A3.12,3.12,0,0,1,211.58,250.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.43,253.46v-5a.46.46,0,0,1,.47-.47h2.79a.48.48,0,0,1,0,1h-2.31v1.56h2a.49.49,0,0,1,.47.47.48.48,0,0,1-.47.48h-2V253h2.31a.47.47,0,1,1,0,.94H218.9A.46.46,0,0,1,218.43,253.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.49,253.46v-5a.48.48,0,0,1,.95,0V253h2.32a.47.47,0,1,1,0,.94H224A.47.47,0,0,1,223.49,253.46Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359,331.71c-2.61,31.53-23,100.22-37.23,111.94-9.18,7.54-48.53,15.91-69.15,15.94-8.46,0-14.74-57.95-2-58.78,21.89-1.42,37.38-3.42,43.21-6.43,4.54-2.35,15.94-24.21,46.82-65.87C352.05,313,360.44,314,359,331.71Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76,458.37c-1.07.27-16.24,4.06-25.21,4.61-6.7.41-26,1.08-27.19-6.24-.81-5,10.5-6.73,18.46-8.13,4.2-.74,9.83-3.69,9.26-6.42-1-4.75-11.87-2.64-19.21-.32-14.21,4.48-33.9,13.87-40.14,5.77-2.36-3.06,2-6.69,7.89-9.89-9.13,3.22-18.58,5.42-21.33,2.12-1.59-1.88-1.23-3.89.35-5.93-2.65.25-4.8-.4-6-2.35-2-3.3.18-7,3.95-10.51a3.2,3.2,0,0,1-2-2.08C159,409.37,192,391.45,202,391.34c29.53-.38,58.81,8.75,58.81,8.75C269.84,411.36,263.78,458.35,263.76,458.37Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.32,423.3a48.85,48.85,0,0,0-20.31,3c-8.16,3.09-14.11,7.52-21.32,11.72a.17.17,0,0,0,.17.29c3.43-2,17.42-9.23,21-10.79a46.5,46.5,0,0,1,20.49-4.11C228.4,423.43,228.4,423.31,228.32,423.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,410.23c-7.82.37-15.83.71-23.45,2.66-8.34,2.13-15.59,7-22.7,11.73q-6.39,4.23-12.6,8.73c-.17.13,0,.42.17.3q10.84-7.31,22.12-13.95A61.31,61.31,0,0,1,212,411.65c4.58-.66,9.2-1,13.81-1.28C225.85,410.37,225.86,410.23,225.77,410.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23,398.06c-7.49-.13-14-.28-21.22,2.14-9.53,3.19-19.55,9.93-23.07,12.33-3.9,2.64-7.7,5.42-11.46,8.25-.15.12.05.39.21.27a244,244,0,0,1,26.69-16.73,48.68,48.68,0,0,1,14-5.2,86.93,86.93,0,0,1,14.86-1A0,0,0,0,0,220.23,398.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.91,404.74,308.38,366s23.54-33.42,39.42-48c8.9-8.19,15.37-1.38,15.32,9.55C362.94,365.81,347.91,404.74,347.91,404.74Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.91,404.74,308.38,366s23.54-33.42,39.42-48c8.9-8.19,15.37-1.38,15.32,9.55C362.94,365.81,347.91,404.74,347.91,404.74Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,352.72a35.88,35.88,0,0,1,3.49-3.06c-.8.65-1.57,1.35-2.34,2Zm12.47-17.36c-.84-.37-1.72-.7-2.62-1l0,.19a.13.13,0,0,1,0,.06,2.21,2.21,0,0,1,.05.25c.11.62.22,1.23.32,1.85a44.66,44.66,0,0,0,1.55,7.17v0q-.14,1.37-.3,2.73a24.45,24.45,0,0,1-2.18-7.48A80.64,80.64,0,0,1,352.25,369a.49.49,0,0,1,.1.19c3.08,10.95-.34,20-9.29,26.63,0,.11-.05.21-.08.31-.08.28-.49.15-.47-.12.77-9.44-1.63-20.31,8.15-25.39a147.32,147.32,0,0,0,5.22-17.93c-4.33,8.45-10.29,14-20.2,17.26a.33.33,0,0,1-.6,0,.18.18,0,0,1,0-.17v0A33.59,33.59,0,0,1,344,351.26c3.61-3.74,8.06-4.51,13-4.13a95.05,95.05,0,0,0,.11-32.29C344,331.25,335.6,350.58,326.85,369.6l0,.11c.22,4.79,1.6,10.14.56,15l-1.32-1.29c.72-3.93,0-8.16-.28-12.14a80.08,80.08,0,0,1-1.34,10.55l-.25-.25a97.27,97.27,0,0,0,1.31-10.05c-1.32,2.52-2.58,5.06-3.77,7.64l-.09-.08c1.25-2.6,2.55-5.17,3.88-7.73l.06-.5c-.29.39-.58.76-.88,1.13q-2.08,3.12-3.81,6.36l-.25-.24c.85-1.55,1.76-3.08,2.72-4.56-1.15,1.29-2.34,2.53-3.45,3.85l-1.15-1.14a57.19,57.19,0,0,1,7-6.75.22.22,0,0,0,0-.08.11.11,0,0,1,.17-.07l.62-.54q2.49-7.05,5.44-14c-3.32,3.53-6.67,7.37-10.89,9.59-2.69,1.41-7.38,2.43-11.28,3.07l-.76-.74a45.15,45.15,0,0,0,10-2.9c4.55-2.1,8.86-6.21,12.6-9.84a56.09,56.09,0,0,1-7.14,5,0,0,0,1,1,0-.05c2.57-1.73,5-3.59,7.39-5.56-5,1.7-10.15,2.87-14.85,5.31a60,60,0,0,0-6,3.58l.3-.41a55.24,55.24,0,0,1,5.61-3.42,75.2,75.2,0,0,1,15.37-5.41,26,26,0,0,0-15.19,2.86,26.79,26.79,0,0,0-2.69,1.73l.45-.6,0,0a22.45,22.45,0,0,1,3.09-1.77A25.17,25.17,0,0,1,332.41,353l.25-.21c-6.08-1.53-11.28-1.15-16.21,2.15.62-.84,1.29-1.73,2-2.64,4.08-2.23,8.78-2.69,14.56.22l0,0a171.35,171.35,0,0,1,22.6-38.12,5.77,5.77,0,0,1,2.77.91,100.46,100.46,0,0,1,1.54,17.44c.05.22.09.45.14.67a14.23,14.23,0,0,1,2.88.45C362.94,334.37,362.91,334.87,362.88,335.36Zm-11.35,35.77,0-.14-.2.14-.06,0a.05.05,0,0,0,0,0,3.72,3.72,0,0,0-.47.34,1,1,0,0,0-.18.13c-4.43,3.32-6.43,7.76-6.62,13.47-.05,1.38,0,2.75-.08,4.1a27.3,27.3,0,0,1-.58,5.75s0,0,0,0c3-3.77,6.56-6.55,8-11.42A26.31,26.31,0,0,0,351.53,371.13Zm-15.26-2.83c2.66-5,4.17-10.57,8.41-14.64a20.77,20.77,0,0,1,9.63-5.29c-5.38.45-8.91,2.22-12.52,7.65C339.18,359.94,337.79,364,336.27,368.3Zm0,.48a70.23,70.23,0,0,1,9.4-11.58c1.52-1.56,3.12-3,4.75-4.48-1.61,1.57-3.11,3.24-4.54,4.7a91.63,91.63,0,0,0-9,10.82c3.52-2.92,7.47-5.24,10.68-8.58a77.18,77.18,0,0,0,8.7-11.4H356a21,21,0,0,0-2.09,1.39,18.54,18.54,0,0,1,1.82-1.34,21.27,21.27,0,0,0-11.58,6.29c-3.87,4.11-5.2,9.58-8,14.31Zm20.39-20.53h-.18a82.47,82.47,0,0,1-8.42,11.32,66.78,66.78,0,0,1-11.43,9.06l-.15.21c3.58-2.06,7.54-3.73,10.7-6.33C351.72,358.79,354,353.33,356.65,348.25Zm-33.39,11.56c-4.2,3.1-9.38,5-14.49,6.59l-.39-.38,0,0h0c5.12-1.66,10.29-2.93,14.84-6.19Zm28.42,11-.15.34c-.11.23-.22.46-.32.7-.23,3.89-.36,7.73-1.76,11.45a55.07,55.07,0,0,1-6.1,11.4,2.3,2.3,0,0,1-.06.28,1.43,1.43,0,0,1,0,.22c0,.07-.12.05-.11,0a1.94,1.94,0,0,0,0-.24.09.09,0,0,1-.11-.1.06.06,0,0,1,0-.07c.07-.26.16-.52.23-.79.16-1.58.35-3.16.6-4.73,1-6.3,2.89-12.39,6.7-17.57.21-.31.44-.61.68-.91,0-.21,0-.43,0-.64,0,0,.05,0,.05,0,0,.2,0,.39,0,.58.18-.23.35-.46.54-.69,0,0,.09,0,.06,0-.21.25-.41.51-.61.76l0,.36v.07l.06-.11c.08-.14.16-.29.24-.42S351.72,370.7,351.68,370.79Zm-.53,1.16c-3.11,7-5,14.36-7.56,21.55,0,.2-.07.41-.12.61a66,66,0,0,0,5.74-10.91A38.67,38.67,0,0,0,351.15,372Zm.05-.75c0-.11,0-.22,0-.33-.17.22-.34.45-.49.67A29.49,29.49,0,0,0,345.64,382c-.81,3.23-1.19,6.54-1.74,9.81,1-3.36,2.16-6.7,3.26-10.05a57.29,57.29,0,0,1,4-10.45S351.2,371.24,351.2,371.2Zm9.1-36.61-.08,0a.14.14,0,0,1,0,.06l.11.23q1.06,2.28,2.28,4.46a2.45,2.45,0,0,0,0,.27c-.75-1.39-1.46-2.79-2.12-4.22.63,1.87,1.27,3.76,2,5.62v0l-.06.71a47.52,47.52,0,0,1-1.76-5c-.23-.74-.43-1.48-.61-2.21l-.66-.28s0,0,0,0l.65.26,0-.1c0-.11-.09-.21-.13-.31s0-.06.05,0h0s.07-.06.08,0,.13.36.19.54l.09,0a23.72,23.72,0,0,1,2.57,1.29.49.49,0,0,1,0,.12A20.55,20.55,0,0,0,360.3,334.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.18,369.72l35.73,35s15-38.93,15.21-77.18c0-4.09-.87-7.6-2.46-10Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.85,361.15c6.57,5.45,24,20.76,34,32.19.06.07-.17.32-.24.27-9.76-8.25-28-26.08-34.1-32.08C315.39,361.42,315.73,361,315.85,361.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.32,463.57l-136-.35L325.55,412s-11.76-14.29-9.54-29.8c2.44-17,33-60,35.61-62.47C362,310,372.86,307.4,382.73,312.5,416.66,330,453.32,463.57,453.32,463.57Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.86,402.17a36.45,36.45,0,0,1,.34,4.63c0-1-.14-2.06-.22-3.08Zm9.68,61.3h-1.66a19.54,19.54,0,0,0-2.13-1.34c-4.93-2.65-8.88-1.86-13.69-1.57h0l-.9.05.54.57,0,.06c.7.75,1.34,1.49,2,2.19h-1.43a10.9,10.9,0,0,1-2-3.54c5.16-.92,9.73-1.51,14.61.71A21.71,21.71,0,0,1,412.54,463.47Zm4.08,0h-1.55a70.06,70.06,0,0,1-3.57-10.16l-.09,0c-4.29-1.91-9.12-4.55-11.28-9s-1.34-10.8-.84-15.59a.25.25,0,0,1,.25-.24.23.23,0,0,1,.2.1c7.49,6.29,13.75,13.27,12.17,23.41A74.5,74.5,0,0,0,416.62,463.48ZM410.88,452l.3.14a.27.27,0,0,1,0-.24.34.34,0,0,1,.15-.14c-.13-5.12-.41-9.21-3.83-13.6-2.18-2.78-4.56-5.43-7-8l-.38-.4-.2-.22-.06-.06-.09-.1v.12a.76.76,0,0,1,0,.15c.21,4.19-.17,8.49,1,12.54C402.16,446.94,406.46,450,410.88,452Zm6.29-90.23c-1.67,4.71-3.49,9.3-3.62,14.5h0c0-5.09,1.58-10.23,3.32-15.15C417,361.3,417.06,361.51,417.17,361.73Zm29.31,78.82c-1.08.34-2.17.63-3.25.89h-.06a51.93,51.93,0,0,1-9,20.53c0,.52,0,1-.06,1.55h-1.75a107.29,107.29,0,0,0-1.7-26.33c-.35-1.82-.76-3.62-1.19-5.41a.63.63,0,0,1-.29-.06,101.53,101.53,0,0,1-16.1-9.91l-.62-.3c-7.9,9.28-20,3.23-28.73-1.3l0,0a.46.46,0,0,1,0-.86l.07,0,.14-.06c5.2-2.23,9.9-5.14,15.77-4.37a23.7,23.7,0,0,1,8.46,3,80.76,80.76,0,0,1-19.32-23.95.53.53,0,0,1-.21,0c-10.6-4.14-15.77-12.32-15.67-23.45l-.2-.25c-.17-.24.18-.49.38-.31,7.08,6.3,17.2,10.92,15.36,21.8a149.28,149.28,0,0,0,11.18,15c-4.14-8.55-5-16.67-1.62-26.52a.33.33,0,0,1,.35-.48.24.24,0,0,1,.17.06h0a33.51,33.51,0,0,1,9.39,18.24c.81,5.14-1.26,9.15-4.55,12.9a95.08,95.08,0,0,0,25.72,19.53c-5.21-20.35-15.6-38.68-25.52-57.12,0,0-.07,0-.1-.05-4.63-3.15-10.81-5.52-13.77-10.59-3.2-5.49-2.71-13.09-2.67-19.2,0,0,.29-.17.3-.1,5,3.83,10.36,8.1,13.51,13.64,2.73,4.8,3.1,10.16,3.45,15.53l.06.06a.11.11,0,0,1,0,.18c0,.27,0,.54.05.81q4.14,6.24,7.89,12.77c-.82-4.79-1.87-9.77-1.1-14.47.55-3.38,3.06-8.51,5-12.17l.45,1a45.36,45.36,0,0,0-3.8,9.9c-1.06,4.9-.37,10.82.27,16a56.63,56.63,0,0,1,.28-8.74s.06,0,.06,0c-.17,3.09-.15,6.16,0,9.25,1.65-5,3.82-9.83,4.71-15.05a59.09,59.09,0,0,0,.74-6.42l.15.34a50.15,50.15,0,0,1-.62,6.12,74.93,74.93,0,0,1-4.94,15.54,26,26,0,0,0,6.87-13.85,25.43,25.43,0,0,0,.21-4.36c.09.21.19.43.28.65a24.28,24.28,0,0,1-.49,4.8,25.23,25.23,0,0,1-6.89,12.87c0,.11,0,.21,0,.32,5.45-4.39,8.34-9.34,8.07-16.34.37.87.74,1.73,1.1,2.61-.06,5.7-2.25,10.76-9.15,14.17v0c12.54,22.42,21,47.08,20.71,72a91.11,91.11,0,0,0,8.74-31c.49,1.48,1,2.93,1.41,4.34q-.3,2.94-.84,5.84c.45-1.53.84-3,1.26-4.52.13.4.25.8.37,1.19-.34,1.05-.7,2.09-1.12,3.13,0,0,0,0,0,.05-.12.31-.25.61-.38.91l.14-.05c.82-.26,1.62-.52,2.41-.81C446.27,439.88,446.37,440.22,446.48,440.55Zm-58.27-96.21a70.77,70.77,0,0,1,14.28,23.76c-.77-3.87-1.21-7.75-3.33-11.44C396.31,351.71,392.35,348.07,388.21,344.34Zm14.63,27.06c-3.85-3.49-8-7.07-10.52-11.62-2.61-4.82-3.71-10.68-4.95-16,.56,5.45,1.05,13.19,3.71,17.94C393.61,366.22,398.62,368.63,402.84,371.4Zm-10.49-12.16c2.42,4.67,6.63,8.18,10.46,11.78a255.72,255.72,0,0,0-15.2-26.95C389,349.13,389.92,354.55,392.35,359.24Zm10.95,12.24c-.13-.45-.26-.91-.37-1.37a80.24,80.24,0,0,0-14.77-25.4,199.84,199.84,0,0,1,14.78,26.43ZM387.48,392l.13.06a1.93,1.93,0,0,0,0-.24.2.2,0,0,0,0-.07v-.05a5.28,5.28,0,0,0,0-.56,1.85,1.85,0,0,0,0-.23c0-5.56-2.32-9.83-6.77-13.42-1.09-.88-2.19-1.7-3.25-2.54A28.46,28.46,0,0,1,373.4,371v0c1.23,4.65,1.29,9.18,4.31,13.24A26.44,26.44,0,0,0,387.48,392Zm11.45-10.49c2.42,5.16,5.93,9.7,6.62,15.54A20.65,20.65,0,0,1,404,407.91c2.88-4.57,3.59-8.45,1.43-14.6C403.85,388.86,401.45,385.31,398.93,381.5Zm3.84,28.21a82.29,82.29,0,0,1-4-13.54,67.11,67.11,0,0,1-.36-14.59c0-.08-.05-.16-.07-.24-.51,4.1-1.56,8.26-1.39,12.35.23,5.88,3.22,11,5.68,16.16Zm.4-.65a21.31,21.31,0,0,0,1.95-13c-.95-5.57-4.51-9.93-6.58-15,0,.07,0,.14,0,.21a70.84,70.84,0,0,1,3.59,14.48c.32,2.15.53,4.31.72,6.48-.3-2.22-.72-4.43-1-6.45A92.51,92.51,0,0,0,398.6,382c.2,4.57-.32,9.13.42,13.7a77.39,77.39,0,0,0,3.86,13.81l.17-.24a20.76,20.76,0,0,0,.15-2.51A18.91,18.91,0,0,1,403.17,409.06Zm8.43,12.05-.18-.09-.05,0-.21-.11c-.55-.27-1.09-.55-1.62-.83-3.22-1.7-6.37-3.41-10.14-3.9-4.43-.57-8.13,1.24-12,2.79h0c-.72.28-1.44.56-2.18.81l.11.06.18.09,2.35,1.27c3.48,1.88,7.07,3.7,11,4C403.76,425.58,407.66,423.72,411.6,421.11Zm-23.16-28.72s0,.05,0,0L388,392c.07.29.15.57.22.85,0,0-.06.07-.07,0-.07-.32-.15-.64-.24-.95l-.26-.23-.06-.05.05.12a4.17,4.17,0,0,1,.19.44c0,.1-.1.15-.15.06l-.18-.32-.36-.68c-3-2.53-5.95-4.94-8.09-8.3a55.52,55.52,0,0,1-5.43-11.73l-.19-.22-.15-.17c0-.05,0-.12.08-.08l.18.17a.09.09,0,0,1,.15,0,0,0,0,0,1,.07,0l.48.66q1.75,1.61,3.41,3.32c4.44,4.6,8.18,9.8,10,16,.12.35.22.71.31,1.07Zm-1.39-1.2c-3.68-6.67-8.44-12.65-12.65-19l-.42-.46a65.92,65.92,0,0,0,5.26,11.14A38.85,38.85,0,0,0,387.05,391.19Zm.82.71c-.07-.26-.14-.51-.23-.77a29.51,29.51,0,0,0-5.3-10.39c-2.09-2.6-4.5-4.89-6.78-7.31,2.06,2.85,4,5.77,6.06,8.65,2.12,3.06,4.41,6.09,5.91,9.52l.1.09Zm24.22,29.17c.05,0,0,.09,0,.08l-.55-.18-.09,0a22.72,22.72,0,0,1-12.49,3.06,25.72,25.72,0,0,1-6.89-1.39c-1.34-.45-2.84-.91-4.23-1.51a12.31,12.31,0,0,1-2.35-1.27l-.16-.1h0l-1.07.34c-.13,0-.2-.16-.07-.2l.73-.24a.07.07,0,0,1,.05,0H385l0,0-.15-.11s0-.05,0,0l.23.12c.71-.23,1.43-.46,2.16-.67h0a32.32,32.32,0,0,1,10.55-1.59,38.94,38.94,0,0,1,11.62,2.7c.7.25,1.39.53,2.06.81l.63-.36s0,0,0,0l-.6.36.1.05.33.07a0,0,0,0,1,0,.07Zm-25.74-1.58a73,73,0,0,1,24.3,1.19c-4.13-1.36-8.4-2.83-12.74-3A34,34,0,0,0,386.35,419.49Zm25.1,1.46-.06,0-.23-.05a83,83,0,0,0-25.6-1.15l-.11,0c8.17,4.41,17.61,5.79,25.92,1.23Zm.33,31.76-.54-.46c0,.2,0,.39,0,.59a.1.1,0,0,1-.19,0c0-.27-.06-.54-.09-.81l0,0a.93.93,0,0,1,0,.13s-.05.06-.06,0l-.06-.2v0c-3.1-2.68-6.14-5.62-8-9.33-2-4-2.55-8.49-2.95-12.89l-.11-.13s-.09-.1-.13-.16,0-.09.07-.06l.05.07.1.11a.57.57,0,0,0,0-.13v0s0,0,0,0,0,.06,0,.09,0,.09,0,.13l.34.38-.16-.29-.26-.49a0,0,0,0,1,.05,0c.2.31.4.62.59.93.09.13.17.27.26.41,5.48,6,9.67,13.06,10.39,21.35,0,.05,0,.1,0,.15l.65.59C411.94,452.66,411.85,452.78,411.78,452.71Zm-.8-.92a36.29,36.29,0,0,0-3.32-11.38,43.93,43.93,0,0,0-6.34-9.06c1.48,2.49,2.76,5.08,4.05,7.69,0,0,0,0,0,0-1.46-2.89-3.12-5.68-4.69-8.51-.2-.25-.41-.49-.61-.73.6,4,1.16,8.19,2.8,12,1.76,4,4.77,7,7.95,9.84a54.44,54.44,0,0,0-4-9.57,0,0,0,0,1,0,0,48.41,48.41,0,0,1,4.05,9.66Zm-1.81,11.67h-.76a21.26,21.26,0,0,0-2.1-.82,41.07,41.07,0,0,0-9.59-1.64,77.34,77.34,0,0,1,8.52,2.46H403.8c-2.85-1-5.76-1.82-8.73-2.59l-.58,0a39.21,39.21,0,0,0,3.28,2.62h-.43c-.92-.7-1.8-1.43-2.63-2.2l0-.06-.41-.38-.32,0c-.14,0-.14-.16-.05-.23a.08.08,0,0,1,0-.12l-.17-.18a.05.05,0,1,1,.07-.08l.31.28.47.09c.16,0,.32,0,.48,0h0a42.57,42.57,0,0,1,11.39,1.78A20.46,20.46,0,0,1,409.17,463.46Zm36.93-24.11a17.78,17.78,0,0,1-2.25.82l-.1.17a1.29,1.29,0,0,1-.09.16c-.07.11-.26,0-.19-.09l.09-.16-.25.07-.16.13c-.06,0-.11,0-.12-.06-.36.09-.72.18-1.08.24s-.25-.3,0-.34c.55-.1,1.1-.24,1.64-.39l.39-.34a.35.35,0,0,1,.05-.08s0,0,0-.05c.46-.83.9-1.67,1.33-2.51l.12.39c-.33.61-.66,1.21-1,1.8l1.22-1.1c0,.09.06.18.08.26-.53.48-1.06.93-1.6,1.37l-.06.1A16.82,16.82,0,0,0,446,439C446,439.13,446.07,439.24,446.1,439.35Zm-94.54-87.66c.77-.68,1.54-1.38,2.34-2a35.88,35.88,0,0,0-3.49,3.06Zm-24.68,18c.26,5.6,2.1,12-.17,17.37-1.72,4.11-5.35,7.39-9.06,10.23-.11-.32-.21-.66-.31-1,3.16-3,6.36-6.45,7.85-9.84,2.08-4.73,1-10.18.65-15.22-.46,5.17-.79,10.69-2.93,15.39a42.59,42.59,0,0,1-5.82,8.84c0-.12-.07-.24-.1-.37a43.21,43.21,0,0,0,5.46-8.16c2.28-4.74,2.54-10.23,3.11-15.45A222.64,222.64,0,0,0,316.27,392l-.09-.49c2.76-6.87,6-13.55,9.4-20.14l.06-.5c-.29.39-.58.76-.88,1.13a75.5,75.5,0,0,0-8.8,17.95c0-.37-.08-.74-.12-1.11a74.26,74.26,0,0,1,7.58-15.28c-2.62,2.94-5.46,5.63-7.13,9.55-.18.42-.34.83-.5,1.25,0-.7.12-1.41.22-2.12a27.47,27.47,0,0,1,.59-2.82c2.29-3.93,5.74-6.91,9.2-9.9a.22.22,0,0,0,0-.08.11.11,0,0,1,.17-.07l.62-.54q2.49-7.05,5.44-14a61.79,61.79,0,0,1-8.35,8c.52-1,1.07-2,1.62-3,2.26-1.81,4.4-3.87,6.38-5.79a55.33,55.33,0,0,1-5.33,3.92l.19-.35c1.84-1.31,3.62-2.7,5.36-4.14-1.21.41-2.43.79-3.65,1.18.09-.17.19-.33.29-.5,1.26-.36,2.52-.7,3.76-1-1-.09-2.06-.14-3.08-.13l.1-.17a21.2,21.2,0,0,1,3.08.25l.25-.21a28.42,28.42,0,0,0-3-.6c.17-.28.33-.57.51-.85a20.49,20.49,0,0,1,2.82,1.18l0,0A178.48,178.48,0,0,1,351.36,320a3.59,3.59,0,0,1,.26-.27,47.48,47.48,0,0,1,4.67-3.88C343.64,332,335.42,351,326.85,369.6Zm48.78-12-.07,0a.33.33,0,0,1-.13-.07c-4.91-2.81-10.07-4.81-13-10a23.59,23.59,0,0,1-2.73-8.53A80.64,80.64,0,0,1,352.25,369a.49.49,0,0,1,.1.19c3.08,10.95-.34,20-9.29,26.63,0,.11-.05.21-.08.31-.08.28-.49.15-.47-.12.77-9.44-1.63-20.31,8.15-25.39a147.32,147.32,0,0,0,5.22-17.93c-4.33,8.45-10.29,14-20.2,17.26a.33.33,0,0,1-.6,0,.18.18,0,0,1,0-.17v0A33.59,33.59,0,0,1,344,351.26c3.61-3.74,8.06-4.51,13-4.13a95.19,95.19,0,0,0,.18-31.88c.36-.26.73-.5,1.1-.73a100.67,100.67,0,0,1,1.68,18.23c.05.22.09.45.14.67,12.17.73,14.61,14,16.25,23.73v.06A.45.45,0,0,1,375.66,357.73Zm-24.13,13.4,0-.14-.2.14-.06,0a.05.05,0,0,0,0,0,3.72,3.72,0,0,0-.47.34,1,1,0,0,0-.18.13c-4.43,3.32-6.43,7.76-6.62,13.47-.05,1.38,0,2.75-.08,4.1a27.3,27.3,0,0,1-.58,5.75s0,0,0,0c3-3.77,6.56-6.55,8-11.42A26.31,26.31,0,0,0,351.53,371.13Zm-15.26-2.83c2.66-5,4.17-10.57,8.41-14.64a20.77,20.77,0,0,1,9.63-5.29c-5.38.45-8.91,2.22-12.52,7.65C339.18,359.94,337.79,364,336.27,368.3Zm0,.48a70.23,70.23,0,0,1,9.4-11.58c1.52-1.56,3.12-3,4.75-4.48-1.61,1.57-3.11,3.24-4.54,4.7a91.63,91.63,0,0,0-9,10.82c3.52-2.92,7.47-5.24,10.68-8.58a77.18,77.18,0,0,0,8.7-11.4H356a21,21,0,0,0-2.09,1.39,18.54,18.54,0,0,1,1.82-1.34,21.27,21.27,0,0,0-11.58,6.29c-3.87,4.11-5.2,9.58-8,14.31Zm20.39-20.53h-.18a82.47,82.47,0,0,1-8.42,11.32,66.78,66.78,0,0,1-11.43,9.06l-.15.21c3.58-2.06,7.54-3.73,10.7-6.33C351.72,358.79,354,353.33,356.65,348.25Zm16.57,6.81c.63.38,1.26.77,1.87,1.19,0,0,0-.08,0-.12s0-.07,0-.1c-.16-.95-.3-1.91-.44-2.87-.59-3.87-1.31-7.78-3.38-11-2.69-4.23-6.52-6.22-11-7.79l0,.19a.13.13,0,0,1,0,.06,2.21,2.21,0,0,1,.05.25c.11.62.22,1.23.32,1.85.58,3.57,1.11,7.09,3,10.37C365.88,351,369.61,352.85,373.22,355.06Zm12.48-25.54c-2.27,4.46-7.81,7.57-11.95,10.06a.24.24,0,0,1-.38-.2.22.22,0,0,1,0-.08c.5-9.77,2.31-19,11.36-23.81l.86-1.23c.22.14.44.3.66.47l-.23.3a.79.79,0,0,1,0,.09C387.13,319.69,387.93,325.14,385.7,329.52Zm-.37-13.19c0-.11-.05-.21-.07-.32a.28.28,0,0,1-.19.12.36.36,0,0,1-.23,0c-4,3.18-7.1,5.87-8.54,11.25-.92,3.41-1.6,6.92-2.22,10.41l-.09.54a2.74,2.74,0,0,0-.05.28l0,.08a.59.59,0,0,1,0,.13l.1-.08.11-.09c3.22-2.7,6.87-5,9.43-8.32C386.57,326.32,386.38,321.07,385.33,316.33Zm-33.65,54.46-.15.34c-.11.23-.22.46-.32.7-.23,3.89-.36,7.73-1.76,11.45a55.07,55.07,0,0,1-6.1,11.4,2.3,2.3,0,0,1-.06.28,1.43,1.43,0,0,1,0,.22c0,.07-.12.05-.11,0a1.94,1.94,0,0,0,0-.24.09.09,0,0,1-.11-.1.06.06,0,0,1,0-.07c.07-.26.16-.52.23-.79.16-1.58.35-3.16.6-4.73,1-6.3,2.89-12.39,6.7-17.57.21-.31.44-.61.68-.91,0-.21,0-.43,0-.64,0,0,.05,0,.05,0,0,.2,0,.39,0,.58.18-.23.35-.46.54-.69,0,0,.09,0,.06,0-.21.25-.41.51-.61.76l0,.36v.07l.06-.11c.08-.14.16-.29.24-.42S351.72,370.7,351.68,370.79Zm-.53,1.16c-3.11,7-5,14.36-7.56,21.55,0,.2-.07.41-.12.61a66,66,0,0,0,5.74-10.91A38.67,38.67,0,0,0,351.15,372Zm.05-.75c0-.11,0-.22,0-.33-.17.22-.34.45-.49.67A29.49,29.49,0,0,0,345.64,382c-.81,3.23-1.19,6.54-1.74,9.81,1-3.36,2.16-6.7,3.26-10.05a57.29,57.29,0,0,1,4-10.45S351.2,371.24,351.2,371.2ZM375.88,357l-.64-.44s0,0-.05,0l-.09-.09,0,0v.19s0,0-.05,0l0-.25c-.59-.41-1.18-.83-1.76-1.26a32.71,32.71,0,0,1-7.72-7.54,38.82,38.82,0,0,1-4.83-10.83c-.23-.74-.43-1.48-.61-2.21l-.66-.28s0,0,0,0l.65.26,0-.1c0-.11-.09-.21-.13-.31s0-.06.05,0h0s.07-.06.08,0,.13.36.19.54l.09,0a22.88,22.88,0,0,1,10,8.13,25.77,25.77,0,0,1,3,6.35c.43,1.3.95,2.72,1.32,4.15a13.88,13.88,0,0,1,.44,2.87v.09h0l.92.64C376.11,356.85,376,357,375.88,357Zm-15.53-22.11A82.45,82.45,0,0,0,374.84,356l.09.07c-1.41-9.18-6-17.55-14.63-21.44l-.08,0a.14.14,0,0,1,0,.06Zm13.82,20.64a73.15,73.15,0,0,1-13.68-20.13c1.4,4.12,2.8,8.41,5.24,12A34,34,0,0,0,374.17,355.48Zm11.15-39.3v.06l.07-.11s.09,0,.06,0l-.12.16,0,0c-.27,4.09-.79,8.28-2.65,12-2,4-5.24,7.15-8.51,10.12,0,.06,0,.12,0,.17a1.77,1.77,0,0,0,0,.2s-.1,0-.09,0a.29.29,0,0,1,0-.09.68.68,0,0,1,0-.14l-.1.09h0a0,0,0,0,1,0,0l.06-.06a.94.94,0,0,1,.1-.1l.09-.5-.14.32c-.08.16-.15.33-.23.49s-.07,0-.06,0c.12-.34.25-.67.38-1l.18-.48c1.52-8,4.6-15.58,10.81-21.15l.09-.09c0-.3,0-.59.08-.88a.08.08,0,0,1,.15,0c0,.24,0,.48-.05.72l.44-.4c.1-.08.23.07.14.15Zm-.19.18a36,36,0,0,0-7.09,9.51,44.13,44.13,0,0,0-3.42,10.51c1.1-2.68,2.41-5.26,3.71-7.86,0,0,.05,0,0,0-1.44,2.91-2.66,5.91-4,8.87-.07.31-.15.62-.22.93,2.87-2.92,5.85-5.86,7.86-9.44,2.15-3.82,2.7-8,3.08-12.27a54.11,54.11,0,0,0-5.25,8.94h0a48.62,48.62,0,0,1,5.27-9S385.13,316.41,385.13,316.36ZM328.36,452.28c-.76.7-1.51,1.4-2.29,2.07a37.13,37.13,0,0,0,3.44-3.12Zm-8.29,11h-1.38a26.55,26.55,0,0,0-.88-3l.4-2.46A22.85,22.85,0,0,1,320.07,463.23Zm24.52-29.29v0a33.47,33.47,0,0,1-8.6,18.62c-3.56,3.8-8,4.64-13,4.35-.32,2.1-.58,4.19-.76,6.3H320.5A79.75,79.75,0,0,1,327.39,435a.57.57,0,0,1-.1-.19c-3.26-10.9,0-20,8.84-26.79,0-.1.05-.2.08-.31.07-.27.49-.15.47.11-.61,9.46,2,20.29-7.73,25.53a147.28,147.28,0,0,0-4.91,18c4.18-8.52,10-14.2,19.9-17.59a.33.33,0,0,1,.6,0A.22.22,0,0,1,344.59,433.94Zm-16.52-1.08,0,.13.2-.15s0,0,.06,0a.05.05,0,0,0,0,0q.24-.16.48-.36a.62.62,0,0,0,.19-.14c4.36-3.39,6.28-7.86,6.38-13.56,0-1.4,0-2.78,0-4.14a0,0,0,0,0,0,0,27.34,27.34,0,0,1,.48-5.69l0,0c-2.91,3.83-6.45,6.66-7.79,11.55A26.51,26.51,0,0,0,328.07,432.86Zm-4.56,22.94a83.08,83.08,0,0,1,8.24-11.45A67,67,0,0,1,343,435.09a2.43,2.43,0,0,1,.14-.2c-3.54,2.11-7.47,3.85-10.59,6.5-4.49,3.8-6.67,9.29-9.25,14.42Zm19.88-20.38c-2.58,5.09-4,10.64-8.18,14.78a20.66,20.66,0,0,1-9.54,5.45c5.38-.54,8.87-2.37,12.39-7.86C340.61,443.83,341.93,439.75,343.39,435.42Zm.15-.62-.16.14a70.6,70.6,0,0,1-9.21,11.74c-1.49,1.58-3.07,3.08-4.66,4.55,1.57-1.6,3.05-3.28,4.45-4.78a91.52,91.52,0,0,0,8.79-11c-3.47,3-7.39,5.37-10.53,8.76a76.32,76.32,0,0,0-8.51,11.54H324a21.38,21.38,0,0,0,2.08-1.43,20,20,0,0,1-1.81,1.37,21.31,21.31,0,0,0,11.48-6.48C339.54,445.07,340.78,439.58,343.54,434.8Zm32.82.14h0c-.08.1-.35.49-.39.51-7.55,9.84-15,22.4-29,15.65l0,0c-1.73,4.11-3.58,8.16-5.58,12.14h-1.91c4.83-9.57,9.06-19.49,13.39-29.32a.29.29,0,0,1,0-.11c-.36-5.59-2.3-11.92-.12-17.37,2.36-5.9,8.66-10.19,13.5-13.92,0,0,.31.13.26.18.05,6.29,0,13.15-2.44,19-2.1,5.11-6.1,8.69-10.12,12.28a.19.19,0,0,0,0,.08.11.11,0,0,1-.17.07l-.61.55q-2.37,7.1-5.21,14.07c3.27-3.59,6.55-7.48,10.73-9.77,5.13-2.8,17.74-4.26,17.78-4.22S376.42,434.91,376.36,434.94Zm-21.53-3.38a79.93,79.93,0,0,0,10.93-27.27A197.85,197.85,0,0,1,354,432.2c0,.17,0,.34,0,.5C354.25,432.31,354.54,431.93,354.83,431.56Zm11.1-28.1c-3.11,4.25-6.84,8.28-9.05,13.08S354.52,426.8,354,432A255.66,255.66,0,0,0,365.93,403.46Zm.16.65A70.88,70.88,0,0,1,356.14,430c2.57-3,5.37-5.72,7-9.67C365.26,415,365.69,409.66,366.09,404.11Zm-12.33,28.18c.38-5.18.61-10.7,2.68-15.44,2.19-5,6.14-9.5,9.57-13.76-3.95,3.79-9.74,8.94-11.85,14C352.16,421.82,353.34,427.26,353.76,432.29Zm16.56,9.33a30.39,30.39,0,0,1-8.44,6.51,25.17,25.17,0,0,1-14.39,2.5l-.24.2c7.11,1.67,13,.77,18.55-4.3A45.66,45.66,0,0,0,370.32,441.62Zm3.21-4c-1.3,1.08-2.72,2.05-4.07,3a60,60,0,0,1-6.58,4.25,75.63,75.63,0,0,1-15.29,5.66,25.92,25.92,0,0,0,15.14-3.11C367,445,370.26,441.26,373.53,437.63Zm2-2.35c-5,1.5-9.95,2-14.86,4.31-4.53,2.18-8.76,6.36-12.44,10.05a57.48,57.48,0,0,1,7.06-5.16s.06,0,0,0c-2.54,1.78-4.94,3.68-7.3,5.68,5-1.77,10.1-3,14.76-5.55a54.25,54.25,0,0,0,12.12-8.73c-6.2,2.55-12.76,3.65-18.32,7.77h0c5.36-4.1,12.41-6.2,18.8-8.24Zm-39.31-26.21c-.07.27-.15.53-.22.8-.12,1.56-.29,3.12-.51,4.67a0,0,0,0,1,0,0c-.88,6.32-2.67,12.45-6.38,17.7-.22.32-.45.63-.69.94l0,.64s-.05,0,0,0l0-.58c-.18.23-.35.47-.54.7a0,0,0,0,1-.06,0c.21-.25.41-.51.6-.77,0-.12,0-.24,0-.36v-.07l-.06.11-.23.43c-.05.09-.18,0-.14-.09a3.09,3.09,0,0,0,.14-.32c.11-.24.22-.48.32-.72.16-3.9.23-7.73,1.56-11.48a55.57,55.57,0,0,1,5.91-11.5,2.3,2.3,0,0,1,.06-.28,1.43,1.43,0,0,1,0-.22c0-.07.11-.05.11,0a1.94,1.94,0,0,0,0,.24.09.09,0,0,1,.11.1A0,0,0,0,1,336.19,409.07Zm-.82,3c-1,3.38-2.06,6.74-3.1,10.1-1.1,3.55-2.08,7.23-3.86,10.51,0,.05,0,.09,0,.13s0,.22,0,.33c.17-.23.34-.46.49-.69a29.56,29.56,0,0,0,4.9-10.54C334.54,418.63,334.87,415.31,335.37,412Zm.27-1.68c0-.21.07-.41.11-.62a65.65,65.65,0,0,0-5.55,11A38.46,38.46,0,0,0,328.44,432C331.43,425,333.22,417.57,335.64,410.35ZM318,463.22h-.36c-.06-.18-.14-.35-.21-.53l.09-.6C317.69,462.47,317.85,462.84,318,463.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.09,408.09a125.25,125.25,0,0,1,18.06,3c2.94.76,5.83,1.65,8.71,2.6,1.44.47,2.89.9,4.34,1.31a19.39,19.39,0,0,0,4.65.88.11.11,0,0,1,0,.22,33.47,33.47,0,0,1-4.48-.08,32.47,32.47,0,0,1-4.27-.81c-3-.74-6-1.61-8.93-2.38-6-1.55-12-3.1-18.15-4.21A.25.25,0,0,1,349.09,408.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06,413.49a133.22,133.22,0,0,1,15.08-.73c2.53,0,5,.21,7.54.45,1.2.12,2.39.25,3.59.41s2.6.51,3.92.66c.14,0,.14.23,0,.22-1.25-.11-2.52,0-3.77,0l-3.76-.1c-2.51-.06-5-.1-7.54-.18-5-.17-10-.29-15.07-.29C333.78,413.9,333.8,413.51,334.06,413.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,327.11c33.91,43.21,72.4,123.53,61.55,139.09-12.09,17.33-60.22-37-58.25-39.51,1.67-2.15-12.73-54.13-22.88-91.87S390.86,316.42,399.24,327.11Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.89,379l-55.09,4.54s-9.83-39.72-10.46-61.3c-.35-12.1,6.71-11.92,14.93-4.72C419,342.75,440.89,379,440.89,379Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,355.85s-.13-.49-.16-.62h0c0-.06,0-.08-.1,0s-6.66,10.84-7.6,16.61a31.12,31.12,0,0,0,.28,9.66l1.11-.09a37.42,37.42,0,0,1,.3-10.88c1.16-5.33,3.88-9.53,5.75-14.37l0,.24c-2.33,6.29-5,13.14-5.07,19.89h0c.17-6.93,3.34-12.77,5.15-19.23a54.82,54.82,0,0,1-.57,14.93,53.94,53.94,0,0,1-2.62,9.17l.43,0a55.72,55.72,0,0,0,2.46-9.1,58.11,58.11,0,0,0,.7-7.8c.07-1.66.17-3.38.12-5.08.85,4.82,1.79,9.74,1.11,14.57a23.38,23.38,0,0,1-2.27,7.23h.19a27.7,27.7,0,0,0,2.08-6.13,30.59,30.59,0,0,0,.06-10.67,46,46,0,0,1,1.09,6.59,18.29,18.29,0,0,1-1.85,10.09l1.77-.14C424.45,373.49,421.19,364.27,419,355.85Zm-5.63,21.87c-.13,1.19-.22,2.38-.27,3.58l.22,0c0-1.18.05-2.36.11-3.55C413.44,377.69,413.38,377.68,413.38,377.72Zm-9-4.24c0-.27,0-.54-.05-.81a.11.11,0,0,0,0-.18l-.06-.06c-.35-5.37-.72-10.73-3.45-15.53-3.15-5.54-8.52-9.81-13.51-13.64,0-.07-.32.08-.3.1,0,6.11-.53,13.71,2.67,19.2,3,5.07,9.14,7.44,13.77,10.59,0,0,.07,0,.1.05l4.59,8.51,1.34-.11Q407,377.48,404.35,373.48Zm-5.19-16.82c2.12,3.69,2.56,7.57,3.33,11.44a70.77,70.77,0,0,0-14.28-23.76C392.35,348.07,396.31,351.71,399.16,356.66Zm-8.08,5c-2.66-4.75-3.15-12.49-3.71-17.94,1.24,5.33,2.34,11.19,4.95,16,2.47,4.55,6.67,8.13,10.52,11.62C398.62,368.63,393.61,366.22,391.08,361.71Zm-3.47-17.64A255.72,255.72,0,0,1,402.81,371c-3.83-3.6-8-7.11-10.46-11.78S389,349.13,387.61,344.07Zm15.33,27.07a199.84,199.84,0,0,0-14.78-26.43,80.24,80.24,0,0,1,14.77,25.4c.11.46.24.92.37,1.37Zm-2,11.16a25.63,25.63,0,0,0-2.43-2.65h0a.24.24,0,0,0-.17-.06.33.33,0,0,0-.35.48c-.3.86-.56,1.71-.79,2.55l1-.08c.06-.4.11-.79.16-1.19,0,.08.05.16.07.24,0,.31,0,.62-.05.93l.21,0c0-.15,0-.3,0-.45,0,.15.09.29.13.44l.27,0c-.14-.42-.29-.84-.45-1.25,0-.07,0-.14,0-.21.2.49.41,1,.64,1.45l.21,0c-.16-.31-.31-.62-.46-.93l.61.92Zm-16-2.39c.32,1.37.57,2.4.72,3,.12.2.23.4.33.61l1.34-.11A16.38,16.38,0,0,0,384.93,379.91Zm1.14-64.79a.79.79,0,0,0,0-.09c.11-.14.23-.29.33-.44-.23-.15-.47-.29-.7-.42l-.92,1.32a19.11,19.11,0,0,0-9.19,10.84c.07,1,.15,2,.25,3,.16-.66.32-1.31.5-2,1.44-5.38,4.53-8.07,8.54-11.25a.36.36,0,0,0,.23,0,.28.28,0,0,0,.19-.12c0,.11.05.21.07.32,1.05,4.74,1.24,10-1.79,14a35.44,35.44,0,0,1-6.91,6.3c.05.38.1.76.16,1.15,3.49-2.17,7.17-4.8,8.91-8.23C387.93,325.14,387.13,319.69,386.07,315.12Zm-.15.51c.09-.08,0-.23-.14-.15l-.44.4c0-.24,0-.48.05-.72a.08.08,0,0,0-.15,0c0,.29-.05.58-.08.88l-.09.09a32.84,32.84,0,0,0-9.14,14.58c0,.13,0,.26,0,.39a31.44,31.44,0,0,1,2.07-5.23,36,36,0,0,1,7.09-9.51c0,.05,0,.11,0,.16a48.62,48.62,0,0,0-5.27,9h0a54.11,54.11,0,0,1,5.25-8.94c-.38,4.26-.93,8.45-3.08,12.27a35.59,35.59,0,0,1-5.49,7,2.51,2.51,0,0,0,0,.27,29.81,29.81,0,0,0,6.08-7.85c1.86-3.69,2.38-7.88,2.65-12l0,0,.12-.16s0-.07-.06,0l-.07.11v-.06Zm-7.59,12.89c-.73,1.46-1.46,2.91-2.16,4.38,0,.12,0,.23,0,.35.69-1.58,1.39-3.16,2.16-4.71C378.38,328.52,378.34,328.49,378.33,328.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,374.71c8.42-1.4,31.36-4.55,46.53-4.64.09,0,.13.35,0,.36-12.61,2-38,4.13-46.51,4.79C386.91,375.24,386.85,374.73,387,374.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.51,383q-3.37,0-6.74.14l.43.32c-1-6.07-2.27-12.08-3.63-18.07s-2.86-12-4.65-17.86c.84,6.1,2,12.14,3.23,18.16s2.66,12,4.25,17.95l.09.37.34-.05C388.06,383.68,390.29,383.37,392.51,383Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.38,359.56a16.84,16.84,0,0,0-1.52-3.6,24.62,24.62,0,0,0-2.15-3.28,7,7,0,0,0,.46,1.93,11.48,11.48,0,0,0,.82,1.78A12.53,12.53,0,0,0,380.38,359.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.24,318.15c-.29,2.61-10.45,20.52-22.1,21.35-3.8.26-6.16-20.42-6.16-20.42l-.53-1.49-7.31-20.82,23.19-19.08,3.37-2.57s1.62,5.83,3.57,13.11c.1.34.19.67.28,1s.24.79.34,1.18c.3,1.08.61,2.19.89,3.3.22.84.44,1.66.63,2.55s.42,1.77.64,2.66C376,307.8,377.35,317.05,377.24,318.15Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.27,288.23a44.2,44.2,0,0,1-22.82,29.36l-7.31-20.82,23.19-19.08,3.37-2.57S369.32,281,371.27,288.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.47,279a8.16,8.16,0,0,1,1.54,2.78c1.47,4.63-.6,9.39-3.2,13.16-2.79,4-6.71,7.67-8.06,12.49a8.08,8.08,0,0,0,.24,5.75c1,2,3,3,5.05,3.59s4.87.88,6.35,2.81a6.32,6.32,0,0,1,.62,5.69c-1.48,4.79-6.64,7.29-9.71,11a25.44,25.44,0,0,0-5.86,13.83,24.69,24.69,0,0,0,2.75,13.81,24.21,24.21,0,0,0,4.05,5.67c1.81,1.86,4,3.3,5.89,5.07s3.41,3.87,3.34,6.4c0,1.95-4,8-12.29,11-.59.21-.17,1.27.51,1.27a31.88,31.88,0,0,0,3.91-.17,34,34,0,0,0,26-16.88,35.41,35.41,0,0,0,4.52-16.5c.08-3.21-.1-6.46.52-9.63a17.81,17.81,0,0,1,3.67-7.55c3.37-4.25,7.73-7.65,10.36-12.48a29.8,29.8,0,0,0,3.44-14.15,35.23,35.23,0,0,0-12.5-26.54C396.93,282.79,373.09,278.54,373.47,279Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.68,279.26a13.76,13.76,0,0,1,2.41,5.77,11.41,11.41,0,0,1-.82,5.6c-1.58,4-4.62,7-7.53,10-2.73,2.85-5.48,6-6.11,10.05a9.33,9.33,0,0,0,.54,5.15,7.26,7.26,0,0,0,4.13,3.71c3.28,1.33,7.85,2,9.11,5.87s-1.92,7.41-4.17,10.05c-5.49,6.45-13.57,14-11.39,23.43,1.11,4.77,4.24,9.24,7.43,12.86,2.3,2.62,5.24,5.9,4.62,9.67,0,.14-.23.07-.21-.06.59-4-2.92-6.78-5.39-9.35a33.27,33.27,0,0,1-7-10.5,16.16,16.16,0,0,1,.25-12.24c1.64-4.05,4.38-7.44,7.26-10.67,1.48-1.66,3-3.29,4.42-5a13.67,13.67,0,0,0,3.09-5.17,4.72,4.72,0,0,0-2-5.23c-1.73-1.19-3.78-1.64-5.72-2.37a9.49,9.49,0,0,1-4.48-3.05,8.71,8.71,0,0,1-1.6-4.14,13.72,13.72,0,0,1,2.73-9.52c2.78-3.9,6.78-6.77,9.49-10.72a13.76,13.76,0,0,0,2.64-6.83c.15-2.61-1-4.8-2.12-7.06A.26.26,0,0,1,373.68,279.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.05,289.3c7.92,6.55,11,17.39,9.2,27.3a35.53,35.53,0,0,1-6.94,15.16c-3.19,4.16-7,8-9.28,12.79-2.49,5.32-1.62,11.06-1.61,16.73a31.65,31.65,0,0,1-2.86,13.27,33.78,33.78,0,0,1-18.88,17.51,29.82,29.82,0,0,1-3.21,1,.11.11,0,1,1-.05-.21c8.57-2.28,15.73-8.59,19.84-16.36a31.75,31.75,0,0,0,3.62-12.36c.41-5.34-.76-10.73.35-16,1-5,4.27-9.05,7.45-12.85,3.48-4.15,6.88-8.26,8.81-13.39,3.59-9.52,2.35-20.68-4.26-28.61-7.38-8.85-19.07-11.49-30-12.6l-4.39-.43c-.16,0-.17-.27,0-.26C388,280.56,400.1,281.9,409.05,289.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,273.3c1.7.38,3.56,2.13,3.59,3.3s-5.47,8.38-7.72,8.56-3.18-3.89-3.18-3.89Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52,269c4.07,38.51,27.58,40.44,35.87,39.56,7.53-.8,33.07-4.47,33-43.2s-19.24-49-36.56-48.1S302.45,230.5,306.52,269Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.76,264.86a24,24,0,0,0,2.49-.94,4.23,4.23,0,0,0,2.35-1.43,1.37,1.37,0,0,0-.25-1.65,3.39,3.39,0,0,0-3.43-.28,5,5,0,0,0-2.83,2.21A1.46,1.46,0,0,0,310.76,264.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.84,260.8a26.18,26.18,0,0,1-2.66-.15,4.33,4.33,0,0,1-2.68-.67,1.38,1.38,0,0,1-.24-1.66,3.4,3.4,0,0,1,3.18-1.29,5,5,0,0,1,3.36,1.28A1.46,1.46,0,0,1,336.84,260.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,271.05c0-.1.22.1.23.21.25,2.61,1,5.55,3.44,6.11.08,0,.09.15,0,.15C333,277.49,332.05,273.57,332.23,271.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,268c4.14-.86,5.55,7.48,1.71,8.28S330.73,268.76,334.2,268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.91,268.2c.81.35,1.67,1.07,2.56,1s1.65-1.07,2.18-2c.05-.1.13,0,.15.07.3,1.6,0,3.34-1.71,3.87s-2.89-.75-3.56-2.29C335.41,268.55,335.59,268.06,335.91,268.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.78,272.93c0-.09-.18.16-.16.26.54,2.57.72,5.6-1.46,6.87-.07,0,0,.17,0,.14C319,279.29,318.7,275.28,317.78,272.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,270.64c-4.21.42-3.06,8.8.83,8.42S318.52,270.29,315,270.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.33,271.43c-.61.54-1.15,1.43-1.94,1.6s-1.71-.63-2.41-1.42c-.07-.08-.13,0-.12.11.18,1.6.94,3.2,2.52,3.3s2.28-1.43,2.44-3.08C313.86,271.64,313.57,271.22,313.33,271.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.09,290c-.42.77-.77,1.77-1.65,2.13a7,7,0,0,1-2.89.2c-.08,0-.14.11-.06.16a3.52,3.52,0,0,0,3.59.38,2.79,2.79,0,0,0,1.28-2.83C338.36,289.9,338.15,289.91,338.09,290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.25,284.23s.42,3.93.87,5.72c0,.17.49.14,1.11,0,0,0,0,0,.07,0a8.79,8.79,0,0,0,7.48-5.25c.08-.21-.2-.33-.33-.18a13.28,13.28,0,0,1-7.22,4.17c-.25-.47-.5-6.75-.79-6.7a16.07,16.07,0,0,0-3.84,1.93c-1.12-8.15-.92-16.42-2.15-24.53a.25.25,0,0,0-.5,0c-.82,8.65.26,18.07,1.2,26.52C321.26,287,324.61,284.71,325.25,284.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.53,231.36s.12,6.09,3.22,9.63c6.38,7.28,15.85,2.21,20.24,4.56,4.11,2.2,4.81,9,8.62,11.28,5.28,3.17,10.32-.07,11.81,2.65s5.92,8.83,9.95,9,5.17-64.45-44.43-51a33.92,33.92,0,0,0-16,8.1c-9.55,9.11-9.09,31.23-9.09,31.23s.16-.33,1.4-2.26c1.75-2.72,2.11-4.88,3.43-6.7,2.09-2.86,3.79-2.48,6-5.32C320,238.13,321.53,231.36,321.53,231.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.51,228.47a34,34,0,0,0,.69,7.81,14.08,14.08,0,0,0,3.06,6.91A10.37,10.37,0,0,0,332,246c2.53.2,5.13-.27,7.88,0a7.78,7.78,0,0,1,3.92,1.52,10.58,10.58,0,0,1,2.47,3.33c1.21,2.34,2.43,4.64,4.57,5.95a8.64,8.64,0,0,0,7.24.89c2.43-.68,4.92-2.13,7.6-1.73-2.7-.18-4.94,1.4-7.42,2.31a9.38,9.38,0,0,1-7.9-.65c-2.52-1.35-3.85-4-5.07-6.23a9.41,9.41,0,0,0-2.23-2.94,6.61,6.61,0,0,0-3.33-1.22c-2.48-.31-5.12.12-7.82-.12a13.41,13.41,0,0,1-4-.92,8.18,8.18,0,0,1-3.41-2.32,14.86,14.86,0,0,1-2.95-7.46A33.77,33.77,0,0,1,321.51,228.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.21,230.94a27.49,27.49,0,0,1-.45,7.34,12.87,12.87,0,0,1-3.33,6.71,18,18,0,0,1-3,2.25,5.91,5.91,0,0,0-2.11,2.49,19,19,0,0,1-1.29,3.46,8.15,8.15,0,0,1-2.56,2.66,9,9,0,0,0,2-2.93,18.08,18.08,0,0,0,.93-3.48,6.3,6.3,0,0,1,2.32-3.13,20.78,20.78,0,0,0,2.79-2.18,13.75,13.75,0,0,0,3.23-6.09A53.42,53.42,0,0,0,321.21,230.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.79,269s6-13.47,11.94-11.55,3.06,20.32-2.8,23.9a6.54,6.54,0,0,1-9.28-1.79Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.77,262.68c.1,0,.14.11.06.16-4.08,2.65-5.61,7.21-6.41,11.79,1-1.9,2.61-3.14,5.11-2,.13.06.06.26-.07.26a4,4,0,0,0-4.08,2.22A19.35,19.35,0,0,0,373,279c-.13.43-.89.36-.82-.13,0,0,0-.07,0-.1C371,273.18,373.82,264.42,379.77,262.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.06,467.6c-13,7.84-56.75,2.74-115.28-10.57-8.1-1.84,11.22-58,20-56.45,11,1.92,53.37,11.75,56.38,12.86C446.49,422.8,468.85,462.28,460.06,467.6Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.7,406.06s-3.52-1.3-21-11.19c-12.08-6.84-45.89-15.77-76.16,8.84-11.6,9.44-10.05,21.69,3.74,14,9.71-5.4,16-10,19.64-10.84,0,0-6.49,15.72-1.24,24.06A183.33,183.33,0,0,0,320,451.79a38.69,38.69,0,0,0,4.15-2.51A20.73,20.73,0,0,0,344.78,457Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.13,390.19C339,391.65,324,395,312.59,402c-12.62,7.8-34.82,26.25-29,35.5,4.29,6.79,13.39.49,13.39.49s-7.57,9.56-2.35,14.84c4.76,4.82,11.51-.48,11.51-.48s-3.6,6.59,1.88,10.34c6.58,4.52,13-10,23.66-11.22C334.11,451.24,346.13,390.19,346.13,390.19Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06,414c-6.47,2.48-19.74,11.88-26.06,23.74-.14.26,0,.52.17.3a145.65,145.65,0,0,1,26-23.92C323.2,414.07,323.14,414,323.06,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.58,427c-5.37,2.71-18.62,13-24.6,25.24-.14.28,0,.52.18.3a155.19,155.19,0,0,1,24.5-25.42C330.72,427,330.64,426.93,330.58,427Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,452.5a12.77,12.77,0,0,1-6.74,2.35,6.79,6.79,0,0,1-6.06-3.49,7.28,7.28,0,0,1-.72-3.59,13.69,13.69,0,0,1,.76-3.58,22.44,22.44,0,0,1,3.55-6.35l.39.43A17.35,17.35,0,0,1,291,441a8.26,8.26,0,0,1-3.5,0,6.45,6.45,0,0,1-3.07-1.78,7.48,7.48,0,0,1-1.78-3.07,8.76,8.76,0,0,1-.2-3.53,17.29,17.29,0,0,1,2.56-6.42,31.32,31.32,0,0,1,4.3-5.35c1.57-1.63,3.19-3.22,4.83-4.78a125.33,125.33,0,0,1,10.26-9l.49.85a99.45,99.45,0,0,0-9.7,5c-1.57.92-3.07,1.91-4.54,3a32.4,32.4,0,0,1-4.76,2.88,19.37,19.37,0,0,1-5.3,1.78,8.51,8.51,0,0,1-2.89,0,4.23,4.23,0,0,1-2.54-1.55,4.73,4.73,0,0,1-.95-2.8,8,8,0,0,1,.47-2.84,17.5,17.5,0,0,1,2.75-4.86,37.87,37.87,0,0,1,8.13-7.46,78.83,78.83,0,0,1,9.38-5.72,64.43,64.43,0,0,1,20.78-6.77,64.24,64.24,0,0,0-20.54,7.21,78.35,78.35,0,0,0-9.25,5.8,37.2,37.2,0,0,0-7.87,7.41,16.52,16.52,0,0,0-2.57,4.66c-.58,1.63-.67,3.54.36,4.83s2.9,1.5,4.6,1.23a18,18,0,0,0,5-1.72,30.92,30.92,0,0,0,4.6-2.81,54,54,0,0,1,4.61-3.05,89.62,89.62,0,0,1,9.8-5l4-1.77L305,407.84a128.74,128.74,0,0,0-10.2,8.83q-2.46,2.32-4.82,4.74a29.89,29.89,0,0,0-4.21,5.19,16.35,16.35,0,0,0-2.46,6.07,8,8,0,0,0,.14,3.19,6.58,6.58,0,0,0,1.55,2.76,5.73,5.73,0,0,0,2.69,1.61,7.59,7.59,0,0,0,3.22.07,16.72,16.72,0,0,0,6.1-2.51l1.55-1-1.16,1.42a22.46,22.46,0,0,0-3.53,6.14,13.57,13.57,0,0,0-.81,3.44,6.87,6.87,0,0,0,.61,3.41,6.55,6.55,0,0,0,5.76,3.48A12.71,12.71,0,0,0,306.16,452.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.59,428.86c-2-2.25-7.79-9.37-17-14-8.06-4-19.53-6.17-25.51-6.89-.15,0-.22.15-.07.2,5.16,1.76,15.67,4,24.3,8.16A76.06,76.06,0,0,1,441.43,429C441.53,429.09,441.68,429,441.59,428.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.57,243.39a36.29,36.29,0,0,0,57.93,29.15l17.78,4.54-7.4-16.56a36.3,36.3,0,1,0-68.31-17.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.57,243.39a36.55,36.55,0,0,0,5.47,19,40,40,0,0,0,2.89,4.07,40.7,40.7,0,0,0,3.48,3.59c.64.54,1.2,1.16,1.89,1.64l2,1.48c.67.5,1.42.88,2.12,1.32l1.07.64c.37.21.75.37,1.13.55.75.35,1.5.72,2.26,1.06l2.34.85a18.25,18.25,0,0,0,2.4.69c.81.19,1.6.45,2.42.56a34.53,34.53,0,0,0,4.95.54,29.57,29.57,0,0,0,5-.07,36.12,36.12,0,0,0,9.66-2.25,36.86,36.86,0,0,0,8.65-4.82l.13-.1.17,0,17.8,4.46-.51.61-7.44-16.55-.1-.21.12-.21a35.94,35.94,0,0,0,1.19-31.41,37.41,37.41,0,0,0-9.65-13,35.88,35.88,0,0,0-14.37-7.44,36.3,36.3,0,0,0-16.23-.43,36.18,36.18,0,0,0-28.83,35.34Zm0,0a36.47,36.47,0,0,1,14-28.65A36.17,36.17,0,0,1,269.76,208a36.47,36.47,0,0,1,14.72,7.4,36.64,36.64,0,0,1,13.15,29.42,36.08,36.08,0,0,1-4.33,16l0-.43,7.36,16.58.37.83-.88-.23-17.76-4.62.3-.06a36.32,36.32,0,0,1-18.69,7,32.62,32.62,0,0,1-5,0,36.55,36.55,0,0,1-5-.61c-.83-.12-1.63-.4-2.45-.59a20.11,20.11,0,0,1-2.4-.73l-2.36-.88c-.76-.35-1.51-.74-2.26-1.1-.37-.19-.76-.36-1.12-.56l-1.07-.66c-.71-.46-1.45-.85-2.12-1.35l-2-1.52a22.66,22.66,0,0,1-1.89-1.64,41,41,0,0,1-3.48-3.62,42,42,0,0,1-2.88-4.11A36.48,36.48,0,0,1,224.57,243.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,226.87a11.93,11.93,0,1,0,16.87,0A11.92,11.92,0,0,0,244.12,226.87Zm2.42,2.43a2.23,2.23,0,1,1,0,3.16A2.23,2.23,0,0,1,246.54,229.3Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.22,
    y: 237.31,
    width: 3.61,
    height: 10.95,
    transform: "translate(272.21 598.33) rotate(-135)",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.94 241.42 258.69 246.67 259.98 247.96 262.15 247.29 261.48 249.46 263.61 251.59 266.5 251 265.9 253.88 266.38 254.36 268.55 253.69 267.88 255.86 270.06 255.19 269.38 257.37 271.08 259.06 273.96 258.46 273.36 261.34 274.84 262.82 280.69 263.41 280.09 257.57 263.94 241.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.07,
    y: 251.88,
    width: 21.28,
    height: 0.51,
    transform: "translate(282.15 621.14) rotate(-135)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.18,235.31a10.42,10.42,0,0,0,3.06,7.31,10.26,10.26,0,0,0,14.5-.12,10.27,10.27,0,0,0,0-14.37,10.27,10.27,0,0,0-14.5-.13A10.42,10.42,0,0,0,242.18,235.31Zm0,0a10.48,10.48,0,0,1,10.37-10.49,10.49,10.49,0,1,1-10.37,10.49Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.13,
    y: 459.24,
    width: 134.27,
    height: 6.02,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.13,
    y: 459.24,
    width: 67.58,
    height: 6.02,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.61 465.25 166.75 465.25 149.65 376.38 280.5 376.38 297.61 465.25",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.29 465.25 161.43 465.25 144.32 376.38 275.18 376.38 292.29 465.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,420.82a7.19,7.19,0,0,1-7.27,8,8.86,8.86,0,0,1-8.66-8,7.18,7.18,0,0,1,7.27-8A8.87,8.87,0,0,1,226.27,420.82Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpwdIcon);
export default __webpack_public_path__ + "static/media/ResetpwdIcon.8cbc796b0874716eda04df3f737ea7a7.svg";
export { ForwardRef as ReactComponent };